import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import logo from './qadooa-logo.png';
import RiyalIcon from './RiyalIcon';
import { translations } from './i18n';
import API, {
  fetchCustomers, fetchStaff, addStaffApi, deleteUserApi, resetPasswordApi,
  updateUserApi, updateAdminProfileApi, requestCodeApi, changeEmailApi, resetPasswordWithCodeApi,
  requestRegisterCodeApi, requestForgotPasswordCodeApi, resetForgotPasswordApi,
  fetchCurrentUserApi, fetchLocalCustomersApi, updateLocalCustomerApi, deleteLocalCustomerApi,
  fetchCancelledBookingsApi,
  fetchEventsApi, createEventApi, updateEventApi, deleteEventApi,
  fetchDeletedEventsApi, restoreEventApi, purgeEventApi,
  addSeatApi, deleteSeatApi, updateSeatApi, bulkUpdateSeatsApi,
  bookSeatApi, internalBookSeatApi, editInternalBookingApi, reopenSeatApi, cancelMyReservationsApi,
  fetchSeatPricingApi, updateSeatPricingApi, resetSeatPricingApi
} from './api';

/* لغة العرض على مستوى الوحدة (تُستخدم في دوال خارج المكوّن مثل تنسيق الوقت) */
let CURRENT_LANG = 'ar';

/* حدود الحجز: الكراسي 4 — الجلسات و VIP 2 (منفصلة) */
const MAX_CHAIRS   = 4;
const MAX_SESSIONS = 2;

const EMPTY_STAFF = { name: '', email: '', phone: '', password: '', canEdit: true };

/* ===== نص الشروط والأحكام وسياسة الاستخدام ===== */
const TERMS_SECTIONS = [
  {
    title: 'تمهيد:',
    items: [
      'يُعد إنشاء حساب جديد في هذه المنصة، أو استخدامها لحجز المقاعد والجلسات، إقراراً علنياً ومباشراً بالموافقة الكاملة وغير المشروطة على كافة البنود والسياسات الواردة أدناه. وفي حال عدم الموافقة على أي بند منها، يُرجى التوقف عن استخدام المنصة وعدم إتمام عملية التسجيل.'
    ]
  },
  {
    title: 'البند الأول: أهلية الحساب وصحة البيانات الشخصية',
    items: [
      '1. يتحمل المستخدم (الزبون) المسؤولية القانونية الكاملة عن صحة ودقة البيانات المدخلة أثناء إنشاء الحساب، وتحديداً: الاسم الثلاثي، ورقم الجوال، والبريد الإلكتروني.',
      '2. تُعد هذه البيانات المرجع الأساسي والوحيد للتحقق الميداني عند بوابات الدفع والاستقبال بفرع المقهى، ولا يحق للمشترك المطالبة بحجزه أو تمكينه من المقعد في حال عدم تطابق البيانات المدخلة مع هويته الفعلية.',
      '3. يلتزم المستخدم بالمحافظة التامة على سرية بيانات دخوله (كلمة المرور)، ويتحمل وحده المسؤولية عن أي نشاط أو حجز يتم إجراؤه عبر حسابه.'
    ]
  },
  {
    title: 'البند الثاني: سياسة الحجز والحدود التشغيلية',
    items: [
      '1. تطبيقاً لمبدأ تكافؤ الفرص ومنعاً للاحتكار، يُحدد السقف الأعلى للحجز لكل زبون في الفعالية أو المباراة الواحدة بـ (4 كراسي فردية) كحد أقصى، ويُسمح بأن يرافقها حجز (جلستين عاديتين) فقط.',
      '2. يُحظر تجاوز هذه الحدود التشغيلية عبر الحساب الفردي، ولإدارة المقهى الحق المطلق في إلغاء أي حجوزات فائضة أو مشتبه في غرضها الاستثماري أو الاحتكاري دون أدنى مسؤولية.',
      '3. فور اختيار المقعد أو الجلسة، يمنح النظام مهلة زمنية مدتها (10 دقائق فقط) لإتمام عملية السداد الإلكتروني بنجاح، وفي حال انقضاء المهلة دون دفع، يُلغى الحجز تلقائياً ويُعاد طرح المقعد للعموم.'
    ]
  },
  {
    title: 'البند الثالث: سياسة الدفع، الإلغاء، والاسترداد المالي',
    items: [
      '1. الإلغاء المبكر: يحق للزبون إلغاء الحجز واسترداد القيمة المالية كاملة عبر المنصة، شريطة أن يتم تقديم طلب الإلغاء قبل موعد بدء الفعالية أو الجلسة بـ (6 ساعات) على الأقل.',
      '2. الإلغاء المتأخر: في حال كان الوقت المتبقي على بدء الفعالية أو المباراة أقل من 6 ساعات، فإن القيمة المالية المدفوعة تصبح غير مستردة نهائياً، ولا يحق للزبون المطالبة بالتعويض أو تغيير موعد الحجز؛ نظراً لتفويت فرصة بيع المقعد لعملاء آخرين.',
      '3. يخضع الإجراء البنكي لإعادة المبالغ المستردة (Refunds) للمدد الزمنية المعتمدة لدى بوابات الدفع والبنوك المحلية، والتي تتراوح عادةً بين (2 إلى 14 يوم عمل).'
    ]
  },
  {
    title: 'البند الرابع: إخلاء المسؤولية الفنية والتقنية',
    items: [
      '1. يقر الزبون ويعلم بأن هذه المنصة هي منتج برمجي إلكتروني، ومن الطبيعي والمألوف تقنياً تعرضها لبعض الأخطاء غير المقصودة، أو التحديثات الدورية، أو الانقطاع المؤقت في الخدمة، أو البطء في استجابة الخوادم.',
      '2. تُقدَّم خدمات المنصة بوضعها الراهن وحالتها المتاحة (As Is) دون أي ضمانات مطلقة بالخلو التام من العيوب التقنية العارضة.',
      '3. لا تتحمل المنصة أو إدارة المقهى أي مسؤولية قانونية أو تعويضية عن أي خلل مؤقت في تحديث خريطة المقاعد، أو تعطل في معالجة الطلبات، طالما أن الإدارة تتخذ التدابير المعتادة لإصلاح المشاكل فور رصدها.'
    ]
  },
  {
    title: 'البند الخامس: بوابات الدفع وأمن البيانات المالية',
    items: [
      '1. تُعالج كافة العمليات المالية من خلال بوابات دفع إلكترونية وسيطة ومستقلة، ومعتمدة رسمياً من البنك المركزي السعودي (ساما).',
      '2. لا تقوم المنصة بتخزين، أو الاحتفاظ، أو الاطلاع على أي بيانات تخص بطاقات الدفع (مدى، البطاقات الائتمانية) الخاصة بالزبائن، وتقتصر مسؤوليتها على استقبال تأكيد السداد الفوري من البوابة الوسيطة.'
    ]
  },
  {
    title: 'البند السادس: القوة القاهرة والظروف الطارئة',
    items: [
      'في حال إلغاء الفعالية، أو تأجيل المباراة من قبل الجهات الرسمية المنظمة، أو حدوث انقطاع عام في البث الفضائي لظروف خارجة عن إرادة المقهى (قوة قاهرة)، يلتزم المقهى بإعادة المبالغ المدفوعة إلى حسابات الزبائن أو تقييدها كرصيد بديل، دون أي مسؤولية إضافية لتعويض الزبون عن أي أضرار تابعة أو معنوية.'
    ]
  },
  {
    title: 'البند السابع: القانون الواجب التطبيق والاختصاص القضائي',
    items: [
      'تخضع هذه الشروط والأحكام وتُفسر وفقاً للأنظمة واللوائح السارية في المملكة العربية السعودية، وتختص الجهات القضائية والمحاكم السعودية بمدينة الرياض حصرياً بالنظر في أي نزاع أو خلاف قد ينشأ عن تفسير هذه الاتفاقية أو تطبيقها.'
    ]
  }
];

/* تحقق: رقم جوال من 10 خانات أرقام فقط */
const isValidPhone = (p) => /^\d{10}$/.test((p || '').trim());
/* تحقق: صيغة بريد إلكتروني صحيحة */
const isValidEmail = (e) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((e || '').trim());
/* تحقق: كلمة مرور قوية — 8 خانات + حرف كبير + رمز (نفس قاعدة الباك إند) */
const isStrongPassword = (p) => /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/.test(p || '');

/* تطبيع بيانات المستخدم القادمة من الباك إند لتطابق شكل الواجهة */
const mapUser = (u) => ({
  id: u.id,
  name: u.fullName || u.name,
  email: u.email,
  phone: u.phone,
  role: (u.role || '').toLowerCase(),
  permissions: { canEdit: u.canEdit ?? true }
});

/* تنسيق التاريخ والوقت — نظام 12 ساعة بأرقام لاتينية واضحة (ص/م) */
const fmtDate = (iso) => iso ? new Date(iso).toLocaleDateString('en-GB') : '—';
/* عزل اتجاه النص (LRI...PDI) — يمنع انقلاب ترتيب الوقت (رقم + ص/م) لما يكون محاط بنص عربي RTL */
const isolateLTR = (s) => `\u2066${s}\u2069`;
const to12h = (d) => {
  let h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, '0');
  const ampm = h >= 12 ? (CURRENT_LANG === 'en' ? 'PM' : 'م') : (CURRENT_LANG === 'en' ? 'AM' : 'ص');
  h = h % 12; if (h === 0) h = 12;
  return isolateLTR(`${h}:${m}\u00A0${ampm}`);
};
const fmtTime = (iso) => iso ? to12h(new Date(iso)) : '—';
const fmtDateTime = (iso) => iso ? `${fmtDate(iso)} · ${fmtTime(iso)}` : '—';
/* تحويل وقت "HH:MM" (24 ساعة من input) إلى صيغة 12 ساعة للعرض */
const time12FromHHMM = (hhmm) => {
  if (!hhmm) return '—';
  const [hStr, m] = hhmm.split(':');
  let h = parseInt(hStr, 10);
  const ampm = h >= 12 ? (CURRENT_LANG === 'en' ? 'PM' : 'م') : (CURRENT_LANG === 'en' ? 'AM' : 'ص');
  h = h % 12; if (h === 0) h = 12;
  return isolateLTR(`${h}:${m}\u00A0${ampm}`);
};
/* عرض وقت الفعالية: بداية فقط، أو "بداية - نهاية" لو فيه وقت نهاية (بمسافات غير قابلة للكسر
   حوالين الشرطة عشان النطاق كله يضل بسطر واحد وما ينكسر بمنتصف الوقت) */
const fmtEventTimeRange = (ev) => {
  if (!ev?.time) return '—';
  const start = time12FromHHMM(ev.time);
  return ev.endTime ? `${start}\u00A0-\u00A0${time12FromHHMM(ev.endTime)}` : start;
};

/* ===== منطق حالة الفعالية: قادمة / مباشرة / سابقة =====
   المباشرة: من لحظة البداية ولمدة ساعة واحدة.
   بعد الساعة: تصبح سابقة (تبقى ظاهرة لكن لا يمكن الدخول). */
const LIVE_DURATION_MS = 2 * 60 * 60 * 1000; // ساعتان
const getEventStart = (ev) => {
  if (!ev?.rawDate || !ev?.time) return null;
  return new Date(`${ev.rawDate}T${ev.time}`);
};
const getEventEnd = (ev) => {
  const start = getEventStart(ev);
  if (!start) return null;
  if (ev?.endTime) {
    let end = new Date(`${ev.rawDate}T${ev.endTime}`);
    if (!isNaN(end.getTime())) {
      // لو وقت النهاية أصغر أو يساوي البداية معناها يعبر منتصف الليل
      if (end.getTime() <= start.getTime()) end = new Date(end.getTime() + 24 * 60 * 60 * 1000);
      return end;
    }
  }
  return new Date(start.getTime() + LIVE_DURATION_MS);
};
const getEventStatus = (ev, now = new Date()) => {
  const start = getEventStart(ev);
  if (!start || isNaN(start.getTime())) return 'upcoming';
  const startMs = start.getTime();
  const endMs = getEventEnd(ev).getTime();
  const nowMs = now.getTime();
  if (nowMs < startMs) return 'upcoming';
  if (nowMs < endMs) return 'live';
  return 'past';
};

const hasArabicChars = (s) => /[\u0600-\u06FF]/.test(s || '');
/* ===== عرض اسم ثنائي اللغة بترتيب بصري ثابت دايماً: عربي يمين، إنجليزي يسار =====
   بغض النظر عن ترتيب النص المخزّن أو أي شخص كتب أيهم أول. */
const renderBilingualName = (fullName) => {
  if (!fullName) return fullName;
  const clean = fullName.replace(/[\u2066-\u2069]/g, ''); // نشيل أي علامات عزل قديمة لو موجودة
  const dashIdx = clean.indexOf(' - ');
  if (dashIdx === -1) return clean; // اسم بلغة وحدة بس — يُعرض كما هو
  const p1 = clean.slice(0, dashIdx).trim();
  const p2 = clean.slice(dashIdx + 3).trim();
  const arName = hasArabicChars(p1) ? p1 : (hasArabicChars(p2) ? p2 : null);
  const enName = (p1 && !hasArabicChars(p1)) ? p1 : ((p2 && !hasArabicChars(p2)) ? p2 : null);
  if (!arName || !enName) return clean;
  return (
    <span dir="rtl">
      {arName}
      {' - '}
      <bdi dir="ltr">{enName}</bdi>
    </span>
  );
};

/* ===== علامة "حجز داخلي" — عنصر واجهة منفصل تماماً عن نص الاسم، ما يدخل بترتيبه إطلاقاً =====
   يظهر بس لو الحجز داخلي (فيه internalBookedBy)؛ ما يظهر أبداً لحجز زبون حقيقي. */
const InternalBadge = () => (
  <span className="internal-badge" dir="rtl" title="حجز داخلي / Internal booking">
    🧾 حجز داخلي - <bdi dir="ltr">Internal booking</bdi>
  </span>
);

function App() {
  const [lang, setLang] = useState(() => (typeof localStorage !== 'undefined' && localStorage.getItem('lang')) || 'ar');
  const t = (str) => (lang === 'en' ? (translations[str] || str) : str);
  /* عرض اسم الزبون: توافق رجعي مع صيغة قديمة كانت تخزّن "(حجز داخلي)" داخل النص نفسه (نترجمها
     للعرض بس لو اللغة إنجليزي)، ثم نمرّره على منسّق الاسم الثنائي اللغة الجديد */
  const displayName = (name) => {
    if (!name) return name;
    let clean = name;
    if (lang === 'en') {
      clean = clean.replace(/\(حجز داخلي\)/g, `(${translations['حجز داخلي'] || 'Internal booking'})`);
    }
    return renderBilingualName(clean);
  };
  const toggleLang = () => setLang(prev => {
    const nx = prev === 'ar' ? 'en' : 'ar';
    try { localStorage.setItem('lang', nx); } catch (e) {}
    return nx;
  });
  const displayDate = (ev) => {
    if (!ev) return '\u2014';
    if (lang === 'en' && ev.rawDate) {
      const d = new Date(ev.rawDate);
      if (!isNaN(d.getTime())) return d.toLocaleDateString('en-GB', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    return ev.date;
  };
  /* هل الفعالية تعدّي منتصف الليل؟ (وقت النهاية أصغر من أو يساوي وقت البداية) */
  const crossesMidnight = (ev) => !!(ev?.time && ev?.endTime && ev.endTime <= ev.time);
  /* نفس تنسيق displayDate بالضبط، بس لتاريخ خام (YYYY-MM-DD) غير تاريخ الفعالية نفسها — يُستخدم لحساب تاريخ اليوم التالي */
  const formatDateFromRaw = (rawDate) => {
    const d = new Date(`${rawDate}T00:00:00`);
    if (isNaN(d.getTime())) return rawDate;
    if (lang === 'en') {
      return d.toLocaleDateString('en-GB', { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' });
    }
    const dayNames = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    return `${dayNames[d.getDay()]} ${day}/${month}/${d.getFullYear()}`;
  };
  /* تاريخ اليوم التالي بصيغة YYYY-MM-DD انطلاقاً من rawDate الفعالية */
  const nextDayRaw = (rawDate) => {
    const d = new Date(`${rawDate}T00:00:00`);
    d.setDate(d.getDate() + 1);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };
  /* عرض موحّد للتاريخ + الوقت: تاريخين منفصلين لو الفعالية تعدّي منتصف الليل، وإلا تاريخ ووقت عادي */
  const fmtEventWhen = (ev) => {
    if (!ev) return '\u2014';
    if (!crossesMidnight(ev)) {
      return `${displayDate(ev)} · ${fmtEventTimeRange(ev)}`;
    }
    const startLabel = `${displayDate(ev)} · ${time12FromHHMM(ev.time)}`;
    const endLabel = `${formatDateFromRaw(nextDayRaw(ev.rawDate))} · ${time12FromHHMM(ev.endTime)}`;
    return `${startLabel}  ←  ${endLabel}`;
  };
  useEffect(() => { CURRENT_LANG = lang; }, [lang]);
  const seatLabel = (nm) => {
    if (!nm || lang !== 'en') return nm;
    const m = nm
      .replace(/^كرسي\s*/, 'Chair ')
      .replace(/^جلسة\s*/, 'Session ')
      .replace(/^غرفة\s*VIP\s*/, 'VIP Room ');
    return m !== nm ? m : (translations[nm] || nm);
  };
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentView, setCurrentView] = useState('home');
  const [events, setEvents] = useState([]);
  const [eventsLoaded, setEventsLoaded] = useState(false);
  const [sessionChecked, setSessionChecked] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [activeFloor, setActiveFloor] = useState(1);
  const [adminTab, setAdminTab] = useState('stats');
  /* إعدادات الأسعار الافتراضية للمقاعد (للفعاليات الجديدة فقط) */
  const [pricingForm, setPricingForm] = useState({
    chairPrice: 20, sessionPrice: 70, vipPrice: 150,
    chairInfo: '', sessionInfo: '', vipInfo: '', autoArabicName: false
  });
  const [openStat, setOpenStat] = useState(null);
  /* سجل الفعاليات الملغية (أرشيف — يمكن استرجاعها أو حذفها نهائياً) */
  const [deletedEvents, setDeletedEvents] = useState([]);
  const [revenueDate, setRevenueDate] = useState('');

  /* بحث الفعاليات */
  const [searchTitle, setSearchTitle] = useState('');
  const [searchDate, setSearchDate]   = useState('');
  const [searchTime, setSearchTime]   = useState('');

  /* بحث بجدول الحجوزات الحية (موظف/مدير داخل الفعالية) */
  const [mapSearch, setMapSearch] = useState('');

  /* بحث بقائمة الزبائن (لوحة الإدارة) */
  const [customerSearch, setCustomerSearch] = useState('');
  const [localCustomers, setLocalCustomers] = useState([]);
  const [localCustomerSearch, setLocalCustomerSearch] = useState('');
  const [customersFullPage, setCustomersFullPage] = useState(1);
  const [localCustomersFullPage, setLocalCustomersFullPage] = useState(1);

  /* تبويب الفعاليات بالرئيسية: available (متاحة+مباشرة) / past (سابقة) */
  const [eventsTab, setEventsTab] = useState('available');
  /* ساعة حيّة تتحدّث كل 30 ثانية لإعادة تقييم حالة الفعاليات (قادمة/مباشرة/سابقة) */
  const [nowTick, setNowTick] = useState(new Date());

  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [authName, setAuthName] = useState('');
  const [authPhone, setAuthPhone] = useState('');
  const [authEmail, setAuthEmail] = useState('');
  const [authPassword, setAuthPassword] = useState('');
  /* الموافقة على الشروط والأحكام (عند إنشاء حساب جديد) */
  const [authAgree, setAuthAgree] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false);
  /* رمز تحقق البريد عند إنشاء حساب جديد (برمز يُرسل عبر Resend) */
  const [authCodeSent, setAuthCodeSent] = useState(false);
  const [authCodeValue, setAuthCodeValue] = useState('');

  /* نسيت كلمة المرور (قبل الدخول) — برمز يُرسل للبريد عبر Resend */
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotCodeSent, setForgotCodeSent] = useState(false);
  const [forgotCode, setForgotCode] = useState('');
  const [forgotNewPassword, setForgotNewPassword] = useState('');

  /* إعادة تعيين كلمة مرور مستخدم (المدير — بدون رمز) */
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetTargetUser, setResetTargetUser] = useState(null);
  const [resetNewPassword, setResetNewPassword] = useState('');

  /* تعديل بيانات مستخدم (المدير يعدّل أي حساب — بدون رمز) */
  const [showAdminEditUserModal, setShowAdminEditUserModal] = useState(false);
  const [editUserTarget, setEditUserTarget] = useState(null);
  const [showEditLocalCustomerModal, setShowEditLocalCustomerModal] = useState(false);
  const [editLocalCustomerTarget, setEditLocalCustomerTarget] = useState(null);
  const [editLocalCustomerForm, setEditLocalCustomerForm] = useState({ name: '', phone: '' });
  const [editUserForm, setEditUserForm] = useState({ name: '', email: '', phone: '', canEdit: true });

  /* تغيير البريد الإلكتروني (الزبون — برمز تحقق) */
  const [showChangeEmailModal, setShowChangeEmailModal] = useState(false);
  const [emailCodeSent, setEmailCodeSent] = useState(false);
  const [newEmailValue, setNewEmailValue] = useState('');
  const [emailCodeValue, setEmailCodeValue] = useState('');

  /* تغيير كلمة المرور (الزبون — برمز تحقق) */
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [pwCodeSent, setPwCodeSent] = useState(false);
  const [newPasswordValue, setNewPasswordValue] = useState('');
  const [pwCodeValue, setPwCodeValue] = useState('');

  /* تعديل جماعي للمقاعد (وصف + سعر) */
  const [showBulkEditModal, setShowBulkEditModal] = useState(false);
  const [bulkEditTarget, setBulkEditTarget] = useState(null);
  const [bulkEditForm, setBulkEditForm] = useState({ info: '', price: 0 });

  const [showProfileModal, setShowProfileModal] = useState(false);
  const [profileUser, setProfileUser] = useState(null);
  /* سجل الحجوزات الملغية بملف الزبون (الزبون نفسه أو المدير) */
  const [cancelledBookings, setCancelledBookings] = useState([]);
  /* أي قسم من أقسام الحجوزات مفتوح حالياً بالملف الشخصي (current/past/cancelled/null) */
  const [openBookingSection, setOpenBookingSection] = useState(null);
  /* صفحة "عرض الكل" المرقّمة (لما قسم يكون فيه حجوزات كثيرة) */
  const [bookingsFullCategory, setBookingsFullCategory] = useState(null);
  const [bookingsFullPage, setBookingsFullPage] = useState(1);
  const [pastEventsFullPage, setPastEventsFullPage] = useState(1);
  const BOOKINGS_PREVIEW_LIMIT = 5;
  const BOOKINGS_PAGE_SIZE = 10;

  const [showEventModal, setShowEventModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const [eventForm, setEventForm] = useState({ title: '', date: '', time: '', endTime: '' });

  const [showSeatModal, setShowSeatModal] = useState(false);
  const [selectedSeat, setSelectedSeat] = useState(null);
  const [isEditingSeat, setIsEditingSeat] = useState(false);
  const [seatForm, setSeatForm] = useState({ name: '', info: '', price: 0 });

  const [showAddSeatModal, setShowAddSeatModal] = useState(false);
  const [newSeatForm, setNewSeatForm] = useState({ type: 'session', floor: 1, name: '', info: '', price: 0 });

  /* مودال الحجز الداخلي (بيانات لحظية بدون حساب) */
  const [showInternalBookModal, setShowInternalBookModal] = useState(false);
  /* true = وضع تعديل حجز داخلي قائم · false = حجز جديد */
  const [isEditingInternal, setIsEditingInternal] = useState(false);
  /* payments: قائمة دفعات، كل دفعة { method: 'cash' | 'network', amount: '' } */
  const [internalBookForm, setInternalBookForm] = useState({ name: '', phone: '', note: '', payments: [{ method: 'cash', amount: '' }] });

  const [showStaffModal, setShowStaffModal] = useState(false);
  const [staffForm, setStaffForm] = useState({ ...EMPTY_STAFF });

  const timerRef = useRef(null);
  const toastRef = useRef(null);
  const placeRestoredRef = useRef(false);
  const [selected, setSelected] = useState([]);
  const [showCheckout, setShowCheckout] = useState(false);
  const [timerVal, setTimerVal] = useState(600);
  const [toastMsg, setToastMsg] = useState('');
  const [toastOn, setToastOn] = useState(false);

  /* ===== Toast ===== */
  const showToast = (msg) => {
    setToastMsg(msg); setToastOn(true);
    clearTimeout(toastRef.current);
    toastRef.current = setTimeout(() => setToastOn(false), 2600);
  };

  const openStaffModal = () => { setStaffForm({ ...EMPTY_STAFF }); setShowStaffModal(true); };

  /* ===== تحميل الموظفين/الزبائن من الباك إند (المدير فقط) ===== */
  const loadUsers = async () => {
    try {
      const [custRes, staffRes] = await Promise.all([fetchCustomers(), fetchStaff()]);
      const customers = (custRes.data || []).map(mapUser);
      const staff = (staffRes.data || []).map(mapUser);
      setUsers([...customers, ...staff]);
    } catch (err) {
      showToast('تعذّر تحميل بيانات المستخدمين من الباك إند');
    }
  };

  /* ===== تحميل الزبائن المسجلين محلياً (عبر الحجز الداخلي من الموظف/المدير) ===== */
  const loadLocalCustomers = async () => {
    try {
      const res = await fetchLocalCustomersApi();
      setLocalCustomers(res.data || []);
    } catch (err) {
      showToast('تعذّر تحميل الزبائن المسجلين محلياً');
    }
  };

  const replaceEventInState = (updatedEvent) => {
    setEvents(prev => prev.map(ev => ev.id === updatedEvent.id ? updatedEvent : ev));
    setSelectedEvent(prev => prev?.id === updatedEvent.id ? updatedEvent : prev);
  };

  const loadEvents = async () => {
    try {
      const res = await fetchEventsApi();
      setEvents(res.data || []);
      setSelectedEvent(prev => prev ? (res.data || []).find(ev => ev.id === prev.id) || null : null);
    } catch (err) {
      showToast('تعذّر تحميل الفعاليات من الباك إند');
    } finally {
      setEventsLoaded(true);
    }
  };

  const loadDeletedEvents = async () => {
    if (currentUser?.role !== 'admin') return;
    try {
      const res = await fetchDeletedEventsApi();
      setDeletedEvents(res.data || []);
    } catch (err) {
      showToast('تعذّر تحميل سجل الفعاليات الملغية');
    }
  };

  /* ===== إعدادات الأسعار والأوصاف الافتراضية ===== */
  const loadSeatPricing = async () => {
    try {
      const res = await fetchSeatPricingApi();
      setPricingForm({
        chairPrice: res.data.chairPrice,
        sessionPrice: res.data.sessionPrice,
        vipPrice: res.data.vipPrice,
        chairInfo: res.data.chairInfo || '',
        sessionInfo: res.data.sessionInfo || '',
        vipInfo: res.data.vipInfo || '',
        autoArabicName: !!res.data.autoArabicName
      });
    } catch (err) {
      /* تجاهل بصمت لو ما عنده صلاحية */
    }
  };

  const handleSavePricing = async (e) => {
    e.preventDefault();
    const c = parseInt(pricingForm.chairPrice, 10);
    const se = parseInt(pricingForm.sessionPrice, 10);
    const v = parseInt(pricingForm.vipPrice, 10);
    if ([c, se, v].some(n => isNaN(n) || n < 0)) {
      showToast('الرجاء إدخال أسعار صحيحة (0 أو أكثر)');
      return;
    }
    try {
      const res = await updateSeatPricingApi({
        chairPrice: c, sessionPrice: se, vipPrice: v,
        chairInfo: pricingForm.chairInfo, sessionInfo: pricingForm.sessionInfo, vipInfo: pricingForm.vipInfo,
        autoArabicName: !!pricingForm.autoArabicName
      });
      setPricingForm({
        chairPrice: res.data.chairPrice, sessionPrice: res.data.sessionPrice, vipPrice: res.data.vipPrice,
        chairInfo: res.data.chairInfo || '', sessionInfo: res.data.sessionInfo || '', vipInfo: res.data.vipInfo || '',
        autoArabicName: !!res.data.autoArabicName
      });
      showToast('✅ تم حفظ الأسعار والأوصاف الافتراضية');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر حفظ الأسعار'));
    }
  };

  const handleResetPricing = async () => {
    if (!window.confirm(t('إرجاع الأسعار والأوصاف الافتراضية إلى القيم الأصلية؟'))) return;
    try {
      const res = await resetSeatPricingApi();
      setPricingForm(f => ({
        ...f,
        chairPrice: res.data.chairPrice, sessionPrice: res.data.sessionPrice, vipPrice: res.data.vipPrice,
        chairInfo: res.data.chairInfo || '', sessionInfo: res.data.sessionInfo || '', vipInfo: res.data.vipInfo || '',
        autoArabicName: res.data.autoArabicName != null ? !!res.data.autoArabicName : f.autoArabicName
      }));
      showToast('✅ تم إرجاع الأسعار والأوصاف الافتراضية');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر إرجاع الأسعار'));
    }
  };

  useEffect(() => {
    loadEvents();
  }, []);

  /* استرجاع جلسة المستخدم تلقائياً من التوكن المحفوظ عند تحميل/تحديث الصفحة */
  useEffect(() => {
    const restoreSession = async () => {
      const token = localStorage.getItem('token');
      if (!token) { setSessionChecked(true); return; }
      try {
        const res = await fetchCurrentUserApi();
        if (res.data && !res.data.error) {
          setCurrentUser({
            id: res.data.id,
            name: res.data.name,
            phone: res.data.phone,
            email: res.data.email,
            role: (res.data.role || '').toLowerCase()
          });
        } else {
          localStorage.removeItem('token');
        }
      } catch (err) {
        localStorage.removeItem('token');
      } finally {
        setSessionChecked(true);
      }
    };
    restoreSession();
  }, []);

  /* استرجاع "مكان" المستخدم (فعالية يتصفحها أو تبويب إدارة كان فيه) — مرة وحدة بس عند أول
     تحميل للصفحة (بعد ما تجهز الفعاليات والجلسة)، عشان ما يتعارض مع تنقّل المستخدم العادي
     لاحقاً (مثلاً لو ضغط "رجوع" نرجعه فعلاً، مو نفرض عليه يرجع للفعالية من جديد) */
  useEffect(() => {
    if (placeRestoredRef.current) return;
    if (!eventsLoaded || !sessionChecked) return;
    placeRestoredRef.current = true;

    let saved = null;
    try { saved = JSON.parse(localStorage.getItem('appPlace') || 'null'); } catch (e) { saved = null; }
    if (!saved) return;

    if (saved.view === 'map' && saved.eventId) {
      const found = events.find(ev => ev.id === saved.eventId);
      if (found) {
        setSelectedEvent(found);
        setCurrentView('map');
        setActiveFloor(saved.activeFloor || 1);
      }
    } else if (saved.view === 'admin' && currentUser?.role === 'admin') {
      setCurrentView('admin');
      if (saved.adminTab) setAdminTab(saved.adminTab);
    }
  }, [eventsLoaded, sessionChecked, events, currentUser]);

  /* حفظ "مكان" المستخدم أول ما يتغيّر، عشان نرجّعه له بعد أي تحديث للصفحة */
  useEffect(() => {
    if (!eventsLoaded) return;
    try {
      localStorage.setItem('appPlace', JSON.stringify({
        view: currentView,
        eventId: currentView === 'map' ? (selectedEvent?.id || null) : null,
        adminTab: currentView === 'admin' ? adminTab : null,
        activeFloor
      }));
    } catch (e) { /* تجاهل */ }
  }, [currentView, selectedEvent, adminTab, activeFloor, eventsLoaded]);

  useEffect(() => {
    loadEvents();
    if (currentUser?.role === 'admin') {
      loadUsers();
      loadDeletedEvents();
      loadSeatPricing();
      loadLocalCustomers();
    } else if (currentUser?.role === 'staff') {
      loadSeatPricing();
    }
  }, [currentUser]);

  /* تحديث الساعة الحيّة كل 30 ثانية لتغيير حالة الفعاليات تلقائياً */
  useEffect(() => {
    const t = setInterval(() => setNowTick(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  /* مزامنة لحظية: إعادة تحميل الفعاليات كل 12 ثانية عشان حالة المقاعد (محجوز/متاح)
     تنعكس لكل من يتصفح الموقع بدون ما يحتاج يحدّث الصفحة يدوياً */
  useEffect(() => {
    const syncInterval = setInterval(() => { loadEvents(); }, 12000);
    return () => clearInterval(syncInterval);
  }, []);

  /* تحميل سجل الحجوزات الملغية عند فتح الملف الشخصي لزبون (الزبون نفسه أو المدير) */
  const reloadCancelledBookings = async (userId) => {
    try {
      const res = await fetchCancelledBookingsApi(userId);
      setCancelledBookings(res.data || []);
    } catch (err) {
      setCancelledBookings([]);
    }
  };

  useEffect(() => {
    setOpenBookingSection(null);
    const shouldLoad = (showProfileModal || currentView === 'bookingsFull') && profileUser && profileUser.role === 'customer';
    if (shouldLoad) {
      reloadCancelledBookings(profileUser.id);
    } else {
      setCancelledBookings([]);
    }
  }, [showProfileModal, profileUser, currentView]);

  /* ===== اختيار المقاعد (الزبون) — حدود منفصلة ===== */
  const pick = (seat) => {
    if (seat.status !== 'available') { showToast('هذا المقعد غير متاح'); return; }

    const idx = selected.findIndex(s => s.id === seat.id);
    if (idx > -1) { setSelected(prev => prev.filter((_, i) => i !== idx)); return; }

    const isChair = seat.type === 'chair';
    const bookedChairs   = currentUser ? selectedEvent.seats.filter(s => s.status === 'booked' && s.bookedBy?.id === currentUser.id && s.type === 'chair').length : 0;
    const bookedSessions = currentUser ? selectedEvent.seats.filter(s => s.status === 'booked' && s.bookedBy?.id === currentUser.id && s.type !== 'chair').length : 0;
    const selChairs   = selected.filter(s => s.type === 'chair').length;
    const selSessions = selected.filter(s => s.type !== 'chair').length;

    if (isChair && (selChairs + bookedChairs) >= MAX_CHAIRS) {
      showToast(`${t('بحد أقصى')} ${MAX_CHAIRS} ${t('كراسي لكل فعالية')} 🪑`); return;
    }
    if (!isChair && (selSessions + bookedSessions) >= MAX_SESSIONS) {
      showToast(`${t('بحد أقصى')} ${MAX_SESSIONS} ${t('جلسات/غرف لكل فعالية')} 🛋️`); return;
    }
    setSelected(prev => [...prev, seat]);
  };

  /* ===== الدفع الإلكتروني — بيانات الزبون تُسحب تلقائياً ===== */
  const openCheckout = () => {
    if (!currentUser) { showToast('سجّل دخولك لإتمام الحجز'); setShowAuthModal(true); return; }
    setShowCheckout(true);
  };
  const closeCheckout = () => { setShowCheckout(false); };

  const handleCheckoutConfirm = async () => {
    if (!selectedEvent || selected.length === 0) return;
    try {
      let updated = null;
      for (const seat of selected) {
        const res = await bookSeatApi(selectedEvent.id, seat.id);
        updated = res.data;
      }
      if (updated) replaceEventInState(updated);
      setSelected([]); closeCheckout();
      showToast('✅ تم تأكيد الحجز والدفع بنجاح');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر تأكيد الحجز'));
      loadEvents();
    }
  };

  const fmtTimer = (v) => `${String(Math.floor(v / 60)).padStart(2, '0')}:${String(v % 60).padStart(2, '0')}`;

  /* ===== المصادقة (بالبريد الإلكتروني) ===== */
  const handleAuthSubmit = async (e) => {
    e.preventDefault();
    try {
      if (authMode === 'register') {
        if (!authCodeSent) {
          // الخطوة 1: تحقق من البيانات ثم إرسال رمز التحقق للبريد
          if (authName.trim().split(/\s+/).length < 3) { alert('عذراً، يجب إدخال الاسم الثلاثي للتسجيل.'); return; }
          if (!isValidPhone(authPhone)) { alert('رقم الجوال يجب أن يكون 10 أرقام بالضبط.'); return; }
          if (!isValidEmail(authEmail)) { alert('البريد الإلكتروني غير صحيح.'); return; }
          if (!isStrongPassword(authPassword)) { alert('كلمة المرور يجب أن تكون 8 خانات على الأقل وتحتوي حرفاً كبيراً ورمزاً.'); return; }
          if (!authAgree) { alert('يجب الاطلاع والموافقة على الشروط والأحكام وسياسة الاستخدام قبل إنشاء الحساب.'); return; }

          const codeRes = await requestRegisterCodeApi(authEmail.trim());
          if (codeRes.data.error) { alert(codeRes.data.error); return; }
          setAuthCodeSent(true);
          return;
        }

        // الخطوة 2: تأكيد رمز التحقق وإنشاء الحساب فعلياً
        const res = await API.post('/auth/register', {
          fullName: authName.trim(),
          email: authEmail.trim(),
          phone: authPhone.trim(),
          password: authPassword,
          code: authCodeValue.trim()
        });
        if (res.data.error) { alert(res.data.error); return; }
        finishLogin(res.data);
      } else {
        if (!isValidEmail(authEmail)) { alert('البريد الإلكتروني غير صحيح.'); return; }
        const res = await API.post('/auth/login', {
          email: authEmail.trim(),
          password: authPassword
        });
        if (res.data.error) { alert(res.data.error); return; }
        finishLogin(res.data);
      }
    } catch (err) {
       const msg = err.response?.data?.error || 'حدث خطأ!، الرجاء المحاولة لاحقاً أو التواصل معنا عبر +996551518126 رقم الطوارئ للدعم الفني.';
      alert(msg);
    }
  };

  const finishLogin = (data) => {
    localStorage.setItem('token', data.token);
    const user = {
      id: data.id,
      name: data.name,
      phone: data.phone,
      email: data.email,
      role: (data.role || '').toLowerCase()
    };
    setCurrentUser(user);
    setShowAuthModal(false);
    setAuthName(''); setAuthPhone(''); setAuthEmail(''); setAuthPassword(''); setAuthAgree(false);
    setAuthCodeSent(false); setAuthCodeValue('');
    // المدير دايماً يدخل لوحة الإدارة، وأي دور ثاني (زبون/موظف) يضل بنفس الصفحة اللي كان فيها
    // (مثلاً لو كان يختار مقاعد بفعالية معينة، يضل فيها بعد الدخول بدل ما يرجع للرئيسية ويفقد اختياره)
    setCurrentView(prevView => user.role === 'admin' ? 'admin' : prevView);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('appPlace');
    setCurrentUser(null); setCurrentView('home'); setSelected([]); setShowAuthModal(true);
  };

  /* ===== نسيت كلمة المرور (قبل الدخول) — برمز يُرسل للبريد ===== */
  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!forgotCodeSent) {
        // الخطوة 1: طلب رمز تحقق يُرسل للبريد
        if (!isValidEmail(forgotEmail)) { alert('البريد الإلكتروني غير صحيح.'); return; }
        const res = await requestForgotPasswordCodeApi(forgotEmail.trim());
        if (res.data.error) { alert(res.data.error); return; }
        setForgotCodeSent(true);
        return;
      }

      // الخطوة 2: تأكيد الرمز وتعيين كلمة مرور جديدة
      if (!isStrongPassword(forgotNewPassword)) { alert('كلمة المرور يجب أن تكون 8 خانات على الأقل وتحتوي حرفاً كبيراً ورمزاً.'); return; }
      const res = await resetForgotPasswordApi(forgotEmail.trim(), forgotCode.trim(), forgotNewPassword);
      if (res.data.error) { alert(res.data.error); return; }
      alert('✅ تم تعيين كلمة مرور جديدة، سجّل دخولك بها الحين');
      setShowForgotModal(false); setShowAuthModal(true);
      setForgotEmail(''); setForgotCodeSent(false); setForgotCode(''); setForgotNewPassword('');
    } catch (err) {
      alert(err.response?.data?.error || t('تعذّر الاتصال بالخادم.'));
    }
  };

  /* ===== إعادة تعيين كلمة مرور مستخدم (المدير — بدون رمز) ===== */
  const openResetModal = (user) => { setResetTargetUser(user); setResetNewPassword(''); setShowResetModal(true); };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (!isStrongPassword(resetNewPassword)) { showToast('كلمة المرور ضعيفة — 8 خانات + حرف كبير + رمز'); return; }
    try {
      await resetPasswordApi(resetTargetUser.id, resetNewPassword);
      showToast('✅ تم إعادة تعيين كلمة المرور');
      setShowResetModal(false);
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر إعادة التعيين'));
    }
  };

  /* ===== تعديل بيانات أي مستخدم (المدير — بدون رمز) ===== */
  const openAdminEditUser = (user) => {
    setEditUserTarget(user);
    setEditUserForm({ name: user.name, email: user.email, phone: user.phone, canEdit: user.permissions?.canEdit ?? true });
    setShowAdminEditUserModal(true);
  };

  const handleAdminEditUserSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(editUserForm.email)) { showToast('البريد الإلكتروني غير صحيح'); return; }
    if (!isValidPhone(editUserForm.phone)) { showToast('رقم الجوال يجب أن يكون 10 أرقام'); return; }
    try {
      const res = await updateUserApi(editUserTarget.id, {
        name: editUserForm.name,
        email: editUserForm.email,
        phone: editUserForm.phone,
        canEdit: String(editUserForm.canEdit)
      });
      if (res.data.error) { showToast(res.data.error); return; }
      showToast('✅ تم تحديث بيانات المستخدم');
      setShowAdminEditUserModal(false);
      loadUsers();
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر تحديث البيانات'));
    }
  };

  /* ===== تعديل بيانات زبون مسجل محلياً (اسم/جوال بس) ===== */
  const openEditLocalCustomer = (c) => {
    setEditLocalCustomerTarget(c);
    setEditLocalCustomerForm({ name: c.name || '', phone: c.phone || '' });
    setShowEditLocalCustomerModal(true);
  };

  const handleEditLocalCustomerSubmit = async (e) => {
    e.preventDefault();
    if (!editLocalCustomerForm.name.trim()) { showToast('اسم الزبون مطلوب'); return; }
    try {
      const res = await updateLocalCustomerApi(editLocalCustomerTarget.id, {
        name: editLocalCustomerForm.name.trim(),
        phone: editLocalCustomerForm.phone.trim()
      });
      if (res.data.error) { showToast(res.data.error); return; }
      showToast('✅ تم تحديث بيانات الزبون');
      setShowEditLocalCustomerModal(false);
      loadLocalCustomers();
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر تحديث البيانات'));
    }
  };

  const handleDeleteLocalCustomer = async (c) => {
    if (!window.confirm(`${t('متأكد من حذف الزبون')} "${c.name}"؟`)) return;
    try {
      const res = await deleteLocalCustomerApi(c.id);
      if (res.data.error) { showToast(res.data.error); return; }
      showToast('✅ تم حذف الزبون');
      loadLocalCustomers();
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر حذف الزبون'));
    }
  };

  /* ===== تعديل حساب المدير نفسه (بدون رمز) ===== */
  const handleUpdateAdminProfile = async (e) => {
    e.preventDefault();
    const name = e.target.adminName.value;
    const email = e.target.adminEmail.value;
    const phone = e.target.adminPhone.value;
    const password = e.target.adminPassword.value;

    if (!isValidEmail(email)) { showToast('البريد الإلكتروني غير صحيح'); return; }
    if (!isValidPhone(phone)) { showToast('رقم الجوال يجب أن يكون 10 أرقام'); return; }
    if (password && !isStrongPassword(password)) { showToast('كلمة المرور ضعيفة — 8 خانات + حرف كبير + رمز'); return; }

    try {
      const body = { name, email, phone };
      if (password) body.password = password;
      const res = await updateAdminProfileApi(body);
      if (res.data.error) { showToast(res.data.error); return; }
      localStorage.setItem('token', res.data.token);
      const upd = { ...currentUser, name: res.data.name, email: res.data.email, phone: res.data.phone };
      setCurrentUser(upd);
      showToast('✅ تم حفظ بيانات المدير بنجاح');
      e.target.reset();
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر حفظ البيانات'));
    }
  };

  /* ===== تغيير البريد الإلكتروني (الزبون — برمز تحقق) ===== */
  const openChangeEmailModal = () => {
    setNewEmailValue(''); setEmailCodeValue(''); setEmailCodeSent(false);
    setShowChangeEmailModal(true);
  };

  const handleSendEmailCode = async () => {
    try {
      await requestCodeApi();
      setEmailCodeSent(true);
      showToast('📨 تم إرسال رمز التحقق إلى بريدك الإلكتروني');
    } catch (err) {
      showToast('تعذّر إرسال رمز التحقق');
    }
  };

  const handleChangeEmailSubmit = async (e) => {
    e.preventDefault();
    if (!isValidEmail(newEmailValue)) { showToast('البريد الإلكتروني غير صحيح'); return; }
    try {
      const res = await changeEmailApi(newEmailValue.trim(), emailCodeValue.trim());
      if (res.data.error) { showToast(res.data.error); return; }
      localStorage.setItem('token', res.data.token);
      const upd = { ...currentUser, email: res.data.email };
      setCurrentUser(upd);
      showToast('✅ تم تغيير البريد الإلكتروني بنجاح');
      setShowChangeEmailModal(false);
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر تغيير البريد الإلكتروني'));
    }
  };

  /* ===== تغيير كلمة المرور (الزبون — برمز تحقق) ===== */
  const openChangePasswordModal = () => {
    setNewPasswordValue(''); setPwCodeValue(''); setPwCodeSent(false);
    setShowChangePasswordModal(true);
  };

  const handleSendPwCode = async () => {
    try {
      await requestCodeApi();
      setPwCodeSent(true);
      showToast('📨 تم إرسال رمز التحقق إلى بريدك الإلكتروني');
    } catch (err) {
      showToast('تعذّر إرسال رمز التحقق');
    }
  };

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();
    if (!isStrongPassword(newPasswordValue)) { showToast('كلمة المرور ضعيفة — 8 خانات + حرف كبير + رمز'); return; }
    try {
      const res = await resetPasswordWithCodeApi(newPasswordValue, pwCodeValue.trim());
      if (res.data.error) { showToast(res.data.error); return; }
      showToast('✅ تم تغيير كلمة المرور بنجاح');
      setShowChangePasswordModal(false);
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر تغيير كلمة المرور'));
    }
  };

  const getProfileBookings = () => !profileUser ? [] : events.flatMap(ev =>
    ev.seats.filter(s => s.status === 'booked' && s.bookedBy?.id === profileUser.id).map(s => ({ event: ev, seat: s }))
  );

  /* الحجوزات الحالية (قادمة/مباشرة) — الأقرب أولاً */
  const currentBookingsList = () => getProfileBookings()
    .filter(b => getEventStatus(b.event, nowTick) !== 'past')
    .sort((a, b) => (getEventStart(a.event)?.getTime() || 0) - (getEventStart(b.event)?.getTime() || 0));

  /* الحجوزات السابقة (منتهية) — الأحدث أولاً */
  const pastBookingsList = () => getProfileBookings()
    .filter(b => getEventStatus(b.event, nowTick) === 'past')
    .sort((a, b) => (getEventStart(b.event)?.getTime() || 0) - (getEventStart(a.event)?.getTime() || 0));

  const cancelProfileBooking = async (eventId, seatId) => {
    const ev = events.find(e => e.id === eventId);
    const start = ev ? getEventStart(ev) : null;
    if (start && !isNaN(start.getTime())) {
      const hoursLeft = (start.getTime() - Date.now()) / (1000 * 60 * 60);
      if (hoursLeft < 6) {
        showToast('❌ لا يمكن الإلغاء — تبقّى أقل من 6 ساعات على الموعد (لا يُسترد المبلغ)');
        return;
      }
    }
    if (!window.confirm(t('متأكد من إلغاء الحجز؟ سيُسترد المبلغ كاملاً.'))) return;
    try {
      await cancelMyReservationsApi({ eventId, seatKey: seatId, userId: profileUser.id });
      await loadEvents();
      await reloadCancelledBookings(profileUser.id);
      showToast('✅ تم إلغاء الحجز — سيُسترد المبلغ كاملاً');
      // يفتح على طول بقسم "الحجوزات الملغية" عشان يشوف الحجز اللي لغاه فوراً
      setOpenBookingSection('cancelled');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر إلغاء الحجز'));
    }
  };

  /* ===== إلغاء كل الحجوزات الحالية (غير المنتهية) دفعة وحدة ===== */
  const cancelAllProfileBookings = async () => {
    const bookings = currentBookingsList();
    if (bookings.length === 0) return;
    if (currentUser?.role !== 'admin') {
      const locked = bookings.some(b => {
        const st = getEventStart(b.event);
        return st && !isNaN(st.getTime()) && (st.getTime() - Date.now()) / 3600000 < 6;
      });
      if (locked) { showToast('❌ يوجد حجز أقل من 6 ساعات — لا يمكن إلغاء الكل'); return; }
    }
    if (!window.confirm(`${t('إلغاء كل الحجوزات')} (${bookings.length})؟ ${t('سيُسترد المبلغ كاملاً.')}`)) return;
    try {
      await cancelMyReservationsApi({ userId: profileUser.id });
      await loadEvents();
      await reloadCancelledBookings(profileUser.id);
      showToast('✅ تم إلغاء كل حجوزاتك');
      // يفتح على طول بقسم "الحجوزات الملغية" عشان يشوف الحجوزات اللي لغاها فوراً
      setOpenBookingSection('cancelled');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر إلغاء كل الحجوزات'));
    }
  };

  /* ===== نظام طباعة الفواتير الموحّد (فاتورة مفردة أو مجموعة) ===== */
  const escHtml = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  /* رمز الريال السعودي للطباعة (SVG مضمّن يرث لون النص) */
  const RIYAL_SVG = '<svg viewBox="0 0 1124.14 1256.39" width="0.85em" height="0.85em" style="display:inline-block;vertical-align:-0.1em;fill:currentColor" aria-label="ريال"><path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/><path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.28-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-93.16,70.63-122.85,121.85v657.44l-135.2,28.74V0c-50.67,28.45-93.13,70.63-122.85,121.85v784.66l-330.68,70.33c-20.06,44.47-33.32,92.75-38.4,143.37l369.08-78.46v207.68c50.67-28.45,93.16-70.61,122.85-121.85v-112.15l135.2-28.74v135.2l-292.28,62.11h0c-20.06,44.47-33.32,92.75-38.4,143.37l330.68-70.33v135.2l-330.68,70.33h0c-20.06,44.47-33.32,92.75-38.4,143.37l369.08-78.46v-207.68l330.68-70.27Z"/></svg>';

  /* تحويل حجز (فعالية + مقعد) إلى بيانات فاتورة موحّدة */
  const toInvoiceItem = (event, seat, name, phone, statusLabel) => {
    const bb = seat?.bookedBy || {};
    const hasPay = bb.paymentStatus != null;
    return {
      eventTitle: event?.title || '-',
      seatName: seatLabel(seat?.name) || '-',
      name: name || seat?.bookedBy?.name || '-',
      phone: phone || seat?.bookedBy?.phone || '-',
      dateTime: fmtEventWhen(event),
      price: seat?.price != null ? String(seat.price) : '-',
      status: statusLabel || t('محجوز'),
      note: bb.note || null,
      hasPay,
      paidCash: hasPay ? (bb.paidCash || 0) : null,
      paidNetwork: hasPay ? (bb.paidNetwork || 0) : null,
      paidTotal: hasPay ? (bb.paidTotal || 0) : null,
      remaining: hasPay ? (bb.remaining || 0) : null,
      payLabel: hasPay
        ? (bb.paymentStatus === 'paid' ? t('تم الدفع') : bb.paymentStatus === 'partial' ? t('دفع جزئي') : t('لم يتم الدفع'))
        : null
    };
  };

  /* فتح نافذة طباعة تحتوي فاتورة واحدة أو أكثر (كلها فيها الوقت والتاريخ) */
  const openInvoiceWindow = (docTitle, items) => {
    if (!items || items.length === 0) { showToast('لا توجد حجوزات للطباعة'); return; }
    const printedAt = new Date().toLocaleString('en-GB');
    const rows = items.map(it => `
      <div class="inv">
        <div class="inv-brand">${t('قَدُوع كِيف')}</div>
        <div class="inv-line"><span>${t('الفعالية')}</span><b>${escHtml(it.eventTitle)}</b></div>
        <div class="inv-line"><span>${t('الجلسة')}</span><b>${escHtml(it.seatName)}</b></div>
        <div class="inv-line"><span>${t('الاسم')}</span><b>${escHtml(it.name)}</b></div>
        <div class="inv-line"><span>${t('رقم الجوال')}</span><b dir="ltr">${escHtml(it.phone)}</b></div>
        <div class="inv-line"><span>${t('التاريخ والوقت')}</span><b>${escHtml(it.dateTime)}</b></div>
        <div class="inv-line"><span>${t('السعر')}</span><b>${escHtml(it.price)}${it.price === '-' ? '' : ' ' + RIYAL_SVG}</b></div>
        ${it.note ? `<div class="inv-line"><span>${t('ملاحظة')}</span><b>${escHtml(it.note)}</b></div>` : ''}
        ${it.hasPay ? `
          <div class="inv-line"><span>${t('كاش')}</span><b>${escHtml(it.paidCash)} ${RIYAL_SVG}</b></div>
          <div class="inv-line"><span>${t('شبكة')}</span><b>${escHtml(it.paidNetwork)} ${RIYAL_SVG}</b></div>
          <div class="inv-line"><span>${t('المدفوع')}</span><b>${escHtml(it.paidTotal)} ${RIYAL_SVG}</b></div>
          <div class="inv-line"><span>${t('المتبقي')}</span><b>${escHtml(it.remaining)} ${RIYAL_SVG}</b></div>
          <div class="inv-status pay">${escHtml(it.payLabel)}</div>
        ` : ''}
        <div class="inv-status">${escHtml(it.status)}</div>
      </div>`).join('');
    const win = window.open('', '_blank');
    win.document.write(`<!DOCTYPE html><html dir="rtl" lang="ar"><head><meta charset="utf-8"><title>${escHtml(docTitle)}</title>
      <style>
        @media print { .noprint { display:none; } }
        body { font-family: 'Tajawal', Arial, sans-serif; padding: 20px; background:#fff; color:#1a1a1a; }
        .print-meta { text-align:center; font-size: 12px; color:#888; margin-bottom: 16px; }
        .inv { border: 2px dashed #c99700; border-radius: 12px; padding: 22px; max-width: 360px; margin: 0 auto 20px; page-break-inside: avoid; }
        .inv-brand { text-align:center; font-size: 26px; font-weight: 800; color:#c99700; margin-bottom: 18px; }
        .inv-line { display:flex; justify-content:space-between; padding: 9px 0; border-bottom: 1px solid #eee; font-size: 15px; }
        .inv-line span { color:#777; }
        .inv-status { text-align:center; margin-top: 16px; font-weight: 800; font-size: 17px; letter-spacing: 2px; color:#1a7a3a; }
        .inv-status.pay { margin-top: 12px; font-size: 15px; letter-spacing: 1px; color:#0a5; }
        .btn-print { display:block; margin: 10px auto 24px; padding: 11px 30px; font-size: 15px; font-weight:700; background:#c99700; color:#fff; border:none; border-radius:10px; cursor:pointer; font-family:inherit; }
      </style></head><body>
      <button class="btn-print noprint" onclick="window.print()">${t('🖨️ طباعة')}</button>
      <div class="print-meta">${t('تاريخ الطباعة:')} ${escHtml(printedAt)}</div>
      ${rows}
      </body></html>`);
    win.document.close();
  };

  /* طباعة كل فواتير الحجوزات الحالية */
  const printCurrentInvoices = () => {
    const items = currentBookingsList().map(b => toInvoiceItem(b.event, b.seat, profileUser?.name, profileUser?.phone, t('محجوز')));
    openInvoiceWindow(t('فواتير الحجوزات الحالية'), items);
  };

  /* طباعة كل فواتير الحجوزات السابقة */
  const printPastInvoices = () => {
    const items = pastBookingsList().map(b => toInvoiceItem(b.event, b.seat, profileUser?.name, profileUser?.phone, t('منتهي')));
    openInvoiceWindow(t('فواتير الحجوزات السابقة'), items);
  };

  /* طباعة فاتورة واحدة من الملف الشخصي (حالية أو سابقة) */
  const printSingleProfileInvoice = (b) => {
    const isPast = getEventStatus(b.event, nowTick) === 'past';
    openInvoiceWindow(t('فاتورة حجز'), [toInvoiceItem(b.event, b.seat, profileUser?.name, profileUser?.phone, isPast ? t('منتهي') : t('محجوز'))]);
  };

  /* طباعة كل فواتير الحجوزات الملغية بملف الزبون */
  const printCancelledInvoices = () => {
    const items = cancelledBookings.map(c =>
      toInvoiceItem(c.event, c.seat, c.customerName || profileUser?.name, c.customerPhone || profileUser?.phone, t('ملغي'))
    );
    openInvoiceWindow(t('فواتير الحجوزات الملغية'), items);
  };

  /* طباعة فاتورة حجز ملغي واحد */
  const printSingleCancelledInvoice = (c) => {
    openInvoiceWindow(t('فاتورة حجز ملغي'), [toInvoiceItem(c.event, c.seat, c.customerName || profileUser?.name, c.customerPhone || profileUser?.phone, t('ملغي'))]);
  };

  /* ===== بطاقة حجز حالي/سابق — تُستخدم بمعاينة الملف الشخصي وبصفحة "عرض الكل" ===== */
  const renderBookingCard = (b, { showCancel }) => {
    const start = getEventStart(b.event);
    const hoursLeft = start && !isNaN(start.getTime()) ? (start.getTime() - Date.now()) / (1000 * 60 * 60) : 999;
    const canCancel = hoursLeft >= 6;
    const isPast = getEventStatus(b.event, nowTick) === 'past';
    return (
      <div key={`${b.event.id}-${b.seat.id}`} className="invoice-card">
        <div className="invoice-brand">{t('☕ قَدُوع كِيف')}</div>
        <div className="invoice-row"><span>${t('الفعالية')}</span><b>{b.event.title}</b></div>
        <div className="invoice-row"><span>${t('الجلسة')}</span><b>{b.seat.name}</b></div>
        <div className="invoice-row"><span>${t('الاسم')}</span><b>{profileUser.name}</b></div>
        <div className="invoice-row"><span>{t('رقم الجوال')}</span><b dir="ltr">{profileUser.phone || '-'}</b></div>
        <div className="invoice-row"><span>${t('التاريخ والوقت')}</span><b>{fmtEventWhen(b.event)}</b></div>
        <div className="invoice-row"><span>${t('السعر')}</span><b>{b.seat.price} <RiyalIcon /></b></div>
        <div className="invoice-status">{isPast ? t('منتهي') : t('محجوز')}</div>
        <div className="invoice-actions">
          <button className="btn-sm" onClick={() => printSingleProfileInvoice(b)}>{t('🖨️ طباعة هذه الفاتورة')}</button>
        </div>
        {showCancel && (currentUser?.role === 'admin' || currentUser?.id === profileUser.id) && (
          <div className="invoice-actions">
            {currentUser?.role === 'admin' || canCancel
              ? <button className="btn-danger-sm" onClick={() => cancelProfileBooking(b.event.id, b.seat.id)}>{t('إلغاء هذا الحجز')}</button>
              : <span className="cancel-locked">{t('🔒 انتهت مهلة الإلغاء (أقل من 6 ساعات)')}</span>}
          </div>
        )}
      </div>
    );
  };

  /* ===== بطاقة حجز ملغي — تُستخدم بمعاينة الملف الشخصي وبصفحة "عرض الكل" ===== */
  const renderCancelledCard = (c) => (
    <div key={c.id} className="invoice-card">
      <div className="invoice-brand">{t('☕ قَدُوع كِيف')}</div>
      <div className="invoice-row"><span>${t('الفعالية')}</span><b>{c.event?.title}</b></div>
      <div className="invoice-row"><span>${t('الجلسة')}</span><b>{seatLabel(c.seat?.name)}</b></div>
      <div className="invoice-row"><span>${t('الاسم')}</span><b>{c.customerName || profileUser.name}</b></div>
      <div className="invoice-row"><span>{t('رقم الجوال')}</span><b dir="ltr">{c.customerPhone || profileUser.phone || '-'}</b></div>
      <div className="invoice-row"><span>${t('التاريخ والوقت')}</span><b>{fmtEventWhen(c.event)}</b></div>
      <div className="invoice-row"><span>${t('السعر')}</span><b>{c.seat?.price} <RiyalIcon /></b></div>
      <div className="invoice-row"><span>{t('وقت الإلغاء')}</span><b>{c.canceledAt ? new Date(c.canceledAt).toLocaleString('en-GB') : '-'}</b></div>
      <div className="invoice-status">{t('ملغي')}</div>
      <div className="invoice-actions">
        <button className="btn-sm" onClick={() => printSingleCancelledInvoice(c)}>{t('🖨️ طباعة هذه الفاتورة')}</button>
      </div>
    </div>
  );

  /* فتح صفحة "عرض الكل" المرقّمة لقسم معيّن (current/past/cancelled) */
  const openBookingsFullPage = (category) => {
    setBookingsFullCategory(category);
    setBookingsFullPage(1);
    setShowProfileModal(false);
    setCurrentView('bookingsFull');
  };

  /* رجوع من صفحة "عرض الكل" للملف الشخصي */
  const closeBookingsFullPage = () => {
    setCurrentView(currentUser?.role === 'admin' ? 'admin' : 'home');
    setShowProfileModal(true);
  };

  /* طباعة كل حجوزات الفعالية الحالية (موظف/مدير من الخريطة) */
  const printEventInvoices = () => {
    const booked = (selectedEvent?.seats || []).filter(s => s.status === 'booked' && s.bookedBy);
    const items = booked.map(s => toInvoiceItem(selectedEvent, s));
    openInvoiceWindow(`${t('فواتير')} ${selectedEvent?.title || ''}`, items);
  };

  /* طباعة فاتورة مقعد واحد من الخريطة (موظف/مدير) */
  const printSeatInvoice = (seat) => {
    if (!seat?.bookedBy) { showToast('لا يوجد حجز لطباعته'); return; }
    openInvoiceWindow(t('فاتورة حجز'), [toInvoiceItem(selectedEvent, seat)]);
  };

  /* ===== الفعاليات ===== */
  const handleSaveEvent = async (e) => {
    e.preventDefault();
    if (eventForm.endTime && eventForm.time && eventForm.endTime === eventForm.time) {
      alert('وقت نهاية الفعالية يجب أن يختلف عن وقت البداية.');
      return;
    }
    try {
      const payload = { title: eventForm.title, rawDate: eventForm.date, time: eventForm.time, endTime: eventForm.endTime || null };
      const res = editingEvent
        ? await updateEventApi(editingEvent.id, payload)
        : await createEventApi(payload);

      if (editingEvent) {
        replaceEventInState(res.data);
      } else {
        setEvents(prev => [...prev, res.data]);
      }

      setShowEventModal(false);
      setEditingEvent(null);
      setEventForm({ title: '', date: '', time: '', endTime: '' });
      showToast(editingEvent ? t('✅ تم تعديل الفعالية') : t('✅ تم إنشاء الفعالية'));
    } catch (err) {
      showToast(err.response?.data || t('تعذّر حفظ الفعالية'));
    }
  };

  const openEditEvent = (ev, e) => {
    e.stopPropagation();
    setEditingEvent(ev); setEventForm({ title: ev.title, date: ev.rawDate, time: ev.time, endTime: ev.endTime || '' }); setShowEventModal(true);
  };

  /* ===== إلغاء فعالية واحدة (المدير — تُنقل لسجل الملغية) ===== */
  const handleDeleteEvent = async (ev, e) => {
    if (e) e.stopPropagation();
    if (!window.confirm(`${t('متأكد من إلغاء فعالية')} "${ev.title}"؟ ${t('يمكنك استرجاعها لاحقاً من سجل الفعاليات الملغية.')}`)) return;
    try {
      await deleteEventApi(ev.id);
      await loadEvents();
      await loadDeletedEvents();
      if (selectedEvent?.id === ev.id) { setSelectedEvent(null); setCurrentView('home'); }
      showToast('✅ تم إلغاء الفعالية — محفوظة بسجل الملغية');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر إلغاء الفعالية'));
    }
  };

  /* ===== إلغاء كل الفعاليات السابقة دفعة وحدة (المدير — تُنقل للسجل) ===== */
  const handleClearPastEvents = async () => {
    const now = new Date();
    const past = events.filter(ev => getEventStatus(ev, now) === 'past');
    if (past.length === 0) { showToast('لا توجد فعاليات سابقة لحذفها'); return; }
    if (!window.confirm(`${t('سيتم نقل')} ${past.length} ${t('فعالية سابقة لسجل الملغية (يمكن استرجاعها). متأكد؟')}`)) return;
    try {
      for (const ev of past) {
        await deleteEventApi(ev.id);
      }
      await loadEvents();
      await loadDeletedEvents();
      showToast(`✅ ${t('تم نقل')} ${past.length} ${t('فعالية لسجل الملغية')}`);
    } catch (err) {
      showToast(err.response?.data || t('تعذّر نقل الفعاليات السابقة'));
    }
  };

  /* ===== استرجاع فعالية ملغية ===== */
  const handleRestoreEvent = async (ev) => {
    if (!window.confirm(`${t('استرجاع فعالية')} "${ev.title}"؟`)) return;
    try {
      await restoreEventApi(ev.id);
      await loadEvents();
      await loadDeletedEvents();
      showToast('✅ تم استرجاع الفعالية');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر استرجاع الفعالية'));
    }
  };

  /* ===== حذف نهائي لفعالية من السجل ===== */
  const handlePurgeEvent = async (ev) => {
    if (!window.confirm(`${t('حذف نهائي لفعالية')} "${ev.title}"؟ ${t('لا يمكن التراجع بعدها.')}`)) return;
    try {
      await purgeEventApi(ev.id);
      await loadDeletedEvents();
      showToast('🗑️ تم الحذف النهائي');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر الحذف النهائي'));
    }
  };

  /* ===== إفراغ سجل الملغية بالكامل (حذف نهائي) ===== */
  const handlePurgeAll = async () => {
    if (deletedEvents.length === 0) return;
    if (!window.confirm(`${t('حذف نهائي لكل السجل')} (${deletedEvents.length} ${t('فعالية')})؟ ${t('لا يمكن التراجع.')}`)) return;
    try {
      for (const ev of deletedEvents) {
        await purgeEventApi(ev.id);
      }
      await loadDeletedEvents();
      showToast('🗑️ تم إفراغ السجل نهائياً');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر إفراغ السجل'));
    }
  };

  /* ===== سجلّ إلغاء الحجز (يُستخدم عند إعادة فتح مقعد محجوز) ===== */
  const logCancellation = (seat) => {
    if (!seat.bookedBy) return null;
    return {
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
      seatId: seat.id,
      seatName: seatLabel(seat.name),
      type: seat.type,
      customerName: seat.bookedBy.name,
      customerPhone: seat.bookedBy.phone,
      bookedAt: seat.bookedBy.bookedAt || null,
      canceledAt: new Date().toISOString(),
      canceledBy: currentUser?.name || '—'
    };
  };

  /* ===== إجراءات المقعد (موظف/مدير) ===== */
  const handleSeatAction = async (action) => {
    try {
      if (action === 'cancel') {
        if (!window.confirm(t('متأكد من إعادة فتح المقعد؟ سيُلغى الحجز الحالي.'))) return;
        const res = await reopenSeatApi(selectedEvent.id, selectedSeat.id);
        replaceEventInState(res.data);
        showToast('✅ تم إعادة فتح المقعد');
      }

      if (action === 'delete') {
        const warnBooked = selectedSeat.status === 'booked'
          ? ` ⚠️ ${t('تنبيه: هذا المقعد محجوز حالياً وبيانات الحجز بتُفقد نهائياً.')}`
          : '';
        if (!window.confirm(`${t('متأكد من حذف')} "${selectedSeat.name}"؟${warnBooked}`)) return;
        const res = await deleteSeatApi(selectedEvent.id, selectedSeat.id);
        replaceEventInState(res.data);
        showToast('✅ تم حذف المقعد');
      }

      if (action === 'save_edit') {
        const res = await updateSeatApi(selectedEvent.id, selectedSeat.id, {
          name: seatForm.name,
          info: seatForm.info,
          price: parseInt(seatForm.price)
        });
        replaceEventInState(res.data);
        showToast('✅ تم حفظ تعديل المقعد');
      }

      setIsEditingSeat(false);
      setShowSeatModal(false);
    } catch (err) {
      showToast(err.response?.data || t('تعذّر تنفيذ العملية'));
    }
  };

  /* فتح مودال الحجز الداخلي — الحقول تبدأ فاضية (دفعة كاش واحدة فاضية) */
  const openInternalBook = () => {
    setIsEditingInternal(false);
    setInternalBookForm({ name: '', phone: '', note: '', payments: [{ method: 'cash', amount: '' }] });
    setShowInternalBookModal(true);
  };

  /* فتح مودال تعديل حجز داخلي قائم — يعبّي الحقول بالبيانات الحالية */
  const openEditInternalBook = () => {
    const bb = selectedSeat?.bookedBy || {};
    // الاسم الأصلي القابل للتعديل: نفضّل rawName من الباك إند (دقيق ومو مركّب مع أي ترجمة)،
    // ولو مو موجود (سجل قديم) نرجع نشيل الصيغ القديمة يدوياً كتوافق رجعي
    const rawFull = bb.name || '';
    let cleanName;
    if (bb.rawName != null) {
      cleanName = bb.rawName;
    } else {
      const newFormatMatch = rawFull.match(/^(.*?)\s*\(حجز داخلي\s*-\s*Internal booking\)/);
      cleanName = newFormatMatch
        ? newFormatMatch[1].trim()
        : rawFull.replace(/\s*\(حجز داخلي\)\s*$/, '').trim();
    }
    if (cleanName === '-') cleanName = '';
    const payments = [];
    if (bb.paidCash > 0) payments.push({ method: 'cash', amount: String(bb.paidCash) });
    if (bb.paidNetwork > 0) payments.push({ method: 'network', amount: String(bb.paidNetwork) });
    if (payments.length === 0) payments.push({ method: 'cash', amount: '' });
    setInternalBookForm({
      name: cleanName,
      phone: bb.phone && bb.phone !== '-' ? bb.phone : '',
      note: bb.note || '',
      payments
    });
    setIsEditingInternal(true);
    setShowInternalBookModal(true);
  };

  /* ===== مساعدات دفعات الحجز الداخلي ===== */
  /* مجموع المدفوع كاش من كل الدفعات */
  const sumByMethod = (payments, method) =>
    (payments || []).filter(p => p.method === method)
      .reduce((a, p) => a + (parseInt(p.amount) || 0), 0);

  /* إضافة خانة دفعة جديدة */
  const addPaymentRow = () =>
    setInternalBookForm(f => ({ ...f, payments: [...f.payments, { method: 'cash', amount: '' }] }));

  /* حذف خانة دفعة (يبقى دايماً واحدة على الأقل) */
  const removePaymentRow = (idx) =>
    setInternalBookForm(f => ({
      ...f,
      payments: f.payments.length > 1 ? f.payments.filter((_, i) => i !== idx) : f.payments
    }));

  /* تعديل خانة دفعة (المبلغ أرقام فقط، والطريقة كاش/شبكة) */
  const updatePaymentRow = (idx, patch) =>
    setInternalBookForm(f => ({
      ...f,
      payments: f.payments.map((p, i) => i === idx ? { ...p, ...patch } : p)
    }));

  /* تأكيد الحجز الداخلي أو حفظ تعديله (اسم + جوال + ملاحظة + دفعات) */
  const handleInternalBook = async (e) => {
    e.preventDefault();
    const paidCash = sumByMethod(internalBookForm.payments, 'cash');
    const paidNetwork = sumByMethod(internalBookForm.payments, 'network');
    /* الوسم الثنائي "(حجز داخلي - Internal booking)" والترجمة الصوتية التلقائية (لو مفعّلة)
       يحسبها الباك إند لحظياً وقت الحجز — نرسل الاسم كما كتبه الموظف بدون أي تعديل هنا */
    const payload = {
      name: (internalBookForm.name || '').trim(),
      phone: internalBookForm.phone,
      note: internalBookForm.note,
      paidCash,
      paidNetwork
    };
    try {
      const res = isEditingInternal
        ? await editInternalBookingApi(selectedEvent.id, selectedSeat.id, payload)
        : await internalBookSeatApi(selectedEvent.id, selectedSeat.id, payload);
      replaceEventInState(res.data);
      setShowInternalBookModal(false);
      setShowSeatModal(false);
      setIsEditingInternal(false);
      showToast(isEditingInternal ? '✅ تم تعديل الحجز' : '✅ تم الحجز الداخلي');
    } catch (err) {
      showToast(err.response?.data || (isEditingInternal ? t('تعذّر تعديل الحجز') : t('تعذّر الحجز الداخلي')));
    }
  };

  const handleAddSeat = async (e) => {
    e.preventDefault();
    try {
      const res = await addSeatApi(selectedEvent.id, {
        id: `ext-${Date.now()}`,
        type: newSeatForm.type,
        floor: parseInt(newSeatForm.floor),
        name: newSeatForm.name,
        info: newSeatForm.info,
        price: parseInt(newSeatForm.price)
      });
      replaceEventInState(res.data);
      setShowAddSeatModal(false);
      showToast('✅ تم إضافة المقعد');
    } catch (err) {
      showToast(err.response?.data || t('تعذّر إضافة المقعد'));
    }
  };

  /* ===== تعديل جماعي لمقاعد فئة كاملة (وصف + سعر) ===== */
  const openBulkEdit = (type, floor, label) => {
    const sample = selectedEvent.seats.find(s => s.type === type && s.floor === floor);
    setBulkEditTarget({ type, floor, label });
    setBulkEditForm({ info: sample?.info || '', price: sample?.price || 0 });
    setShowBulkEditModal(true);
  };

  const handleBulkEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await bulkUpdateSeatsApi(selectedEvent.id, {
        type: bulkEditTarget.type,
        floor: bulkEditTarget.floor,
        info: bulkEditForm.info,
        price: parseInt(bulkEditForm.price)
      });
      replaceEventInState(res.data);
      setShowBulkEditModal(false);
      showToast(`✅ ${t('تم تحديث كل مقاعد')} "${bulkEditTarget.label}" ${t('دفعة وحدة')}`);
    } catch (err) {
      showToast(err.response?.data || t('تعذّر التعديل الجماعي'));
    }
  };

  /* ===== إضافة موظف — عبر الباك إند ===== */
  const handleAddStaff = async (e) => {
    e.preventDefault();
    if (!isValidPhone(staffForm.phone)) { showToast('رقم جوال الموظف يجب أن يكون 10 أرقام'); return; }
    if (!isValidEmail(staffForm.email)) { showToast('البريد الإلكتروني غير صحيح'); return; }
    if (!isStrongPassword(staffForm.password)) { showToast('كلمة المرور ضعيفة — 8 خانات + حرف كبير + رمز'); return; }
    try {
      await addStaffApi({
        fullName: staffForm.name,
        email: staffForm.email,
        phone: staffForm.phone,
        password: staffForm.password,
        canEdit: staffForm.canEdit
      });
      showToast('✅ تم إضافة الموظف بنجاح');
      setShowStaffModal(false);
      setStaffForm({ ...EMPTY_STAFF });
      loadUsers();
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر إضافة الموظف'));
    }
  };

  /* ===== حذف مستخدم — عبر الباك إند ===== */
  const handleDeleteUser = async (userId) => {
    if (!window.confirm(t('هل أنت متأكد من حذف هذا الحساب نهائياً؟'))) return;
    try {
      await deleteUserApi(userId);
      showToast('✅ تم حذف الحساب');
      loadUsers();
    } catch (err) {
      showToast(err.response?.data?.error || t('تعذّر حذف الحساب'));
    }
  };

  /* ===== رسم المقعد ===== */
  const renderSeat = (seat, extraClass = '') => {
    const isSel   = !!selected.find(s => s.id === seat.id);
    const stCls   = seat.status === 'booked' ? 'booked' : seat.status === 'pending' ? 'pending' : isSel ? 'sel' : 'available';
    const icon    = seat.type === 'chair'
      ? <>🪑</>
      : seat.type === 'vip'
        ? <>👑<span className="sub-ico">📺</span></>
        : <>🛋️<span className="sub-ico">📺</span></>;
    const prText  = seat.status === 'booked' ? t('محجوز') : seat.status === 'pending' ? t('قيد الدفع') : t('متاح');
    const showWho = seat.bookedBy && (currentUser?.role === 'staff' || currentUser?.role === 'admin');
    const isMySeat = currentUser?.role === 'customer' && seat.status === 'booked' && seat.bookedBy?.id === currentUser.id;

    const onClick = () => {
      if (!currentUser || currentUser.role === 'customer') pick(seat);
      else { setSelectedSeat(seat); setShowSeatModal(true); }
    };

    return (
      <div key={seat.id}
        className={`seat ${stCls}${seat.type === 'vip' ? ' vip big' : ''}${extraClass ? ' ' + extraClass : ''}`}
        onClick={onClick} tabIndex={0} role="button"
        aria-label={`${seatLabel(seat.name)} — ${prText}`} onKeyDown={ev => ev.key === 'Enter' && onClick()}>
        <div className="tick">✓</div>
        <div className="ico">{icon}</div>
        <div className="no">{seatLabel(seat.name)}</div>
        <div className="pr">{prText}</div>
        {showWho && (
          <div className="who" onClick={(e) => { e.stopPropagation(); onClick(); }}>
            <div className="who-line who-name who-name-row">
              <span className="who-customer-name">👤 {displayName(seat.bookedBy.name)}</span>
              {seat.bookedBy.internalBookedBy && <InternalBadge />}
            </div>
            {seat.bookedBy.phone && seat.bookedBy.phone !== '-' && (
              <div className="who-line who-phone" dir="ltr">📱 {seat.bookedBy.phone}</div>
            )}
            {seat.bookedBy.note && <div className="who-line who-note">📝 {seat.bookedBy.note}</div>}
            {seat.bookedBy.paymentStatus && (
              <div className="who-pay">
                <div className="who-pay-line">
                  <span>💰 {t('السعر')}: <b>{seat.price}</b></span>
                  <span>{t('مدفوع')}: <b>{seat.bookedBy.paidTotal || 0}</b></span>
                </div>
                {seat.bookedBy.remaining > 0 && (
                  <div className="who-pay-line"><span>{t('المتبقي')}: <b>{seat.bookedBy.remaining}</b></span></div>
                )}
                <div className={`who-pay-badge ${seat.bookedBy.paymentStatus}`}>
                  {seat.bookedBy.paymentStatus === 'paid' ? t('تم الدفع')
                    : seat.bookedBy.paymentStatus === 'partial' ? t('دفع جزئي')
                    : t('لم يتم الدفع')}
                </div>
              </div>
            )}
            {seat.bookedBy.internalBookedBy && <div className="who-line who-by">🧾 {t('بواسطة')} {seat.bookedBy.internalBookedBy}</div>}
          </div>
        )}
        {isMySeat && (
          <div className="who my-seat-note">
            🎉 {t('الله يحييك ضيفنا')} <b>{currentUser.name}</b> {t('حجزك هنا')}
          </div>
        )}
      </div>
    );
  };

  /* ===== مساعدات البيانات ===== */
  const numOf = (s) => parseInt((s.name || '').replace(/\D/g, '')) || 0;
  /* ترتيب ثابت: المقاعد الافتراضية أول (مرتّبة برقمها)، والمقاعد المضافة يدوياً تنضاف دايماً
     بآخر القائمة بنفس ترتيب إضافتها — بغض النظر عن أي رقم موجود باسمها */
  const bySeatOrder = (ascending = true) => (a, b) => {
    const da = a.isDefault ? 0 : 1;
    const db = b.isDefault ? 0 : 1;
    if (da !== db) return da - db;
    if (!a.isDefault) return 0;
    return ascending ? numOf(a) - numOf(b) : numOf(b) - numOf(a);
  };
  const getChairs     = () => (selectedEvent?.seats.filter(s => s.type === 'chair') || []).sort(bySeatOrder(true));
  const getF1Sessions = () => (selectedEvent?.seats.filter(s => s.type === 'session' && s.floor === 1) || []).sort(bySeatOrder(true));
  const getVIP        = () => (selectedEvent?.seats.filter(s => s.type === 'vip') || []).sort(bySeatOrder(true));
  const findUpper     = (n) => (selectedEvent?.seats.filter(s => s.type === 'session' && s.floor === 2) || []).find(s => numOf(s) === n);
  /* كل جلسات الدور الثاني (تشمل المضافة) — مرتّبة تنازلياً كالتصميم الأصلي، والمضافة بالآخر */
  const getF2Sessions = () => (selectedEvent?.seats.filter(s => s.type === 'session' && s.floor === 2) || []).sort(bySeatOrder(false));

  const bookedCount    = selectedEvent?.seats.filter(s => s.status === 'booked').length || 0;
  const pendingCount   = selectedEvent?.seats.filter(s => s.status === 'pending').length || 0;
  const availableCount = selectedEvent?.seats.filter(s => s.status === 'available').length || 0;
  /* عدد الحجوزات الملغاة لهالفعالية — يشمل إلغاء الزبون + إعادة فتح الموظف/المدير (كلها تُسجّل بسجل الملغاة) */
  const cancelledCount = selectedEvent?.cancelledLog?.length || 0;
  const revenue        = selectedEvent?.seats.filter(s => s.status === 'booked').reduce((a, s) => a + s.price, 0) || 0;

  const canManage = currentUser?.role === 'admin' || currentUser?.role === 'staff';
  /* هل الفعالية المفتوحة حالياً سابقة؟ (المدير يدخلها للاطلاع فقط) */
  const viewingPast = selectedEvent && getEventStatus(selectedEvent, nowTick) === 'past';
  /* صلاحية التعديل الفعلية داخل الخريطة: تُمنع كلياً لو الفعالية سابقة */
  const canEditSeats = canManage && !viewingPast;
  const bookingRows = (selectedEvent?.seats.filter(s => s.status !== 'available') || []);

  /* فلترة جدول الحجوزات الحية بالبحث (رقم الجلسة، النوع، اسم الزبون، رقم الجوال) */
  const seatTypeLabel = (type) => type === 'chair' ? t('كرسي') : type === 'vip' ? t('غرفة VIP') : t('جلسة');
  const mapSearchNorm = mapSearch.trim().toLowerCase();
  const filteredBookingRows = !mapSearchNorm ? bookingRows : bookingRows.filter(s => {
    const haystack = [
      seatLabel(s.name), s.id, s.type, seatTypeLabel(s.type),
      s.bookedBy?.name, s.bookedBy?.phone
    ].filter(Boolean).join(' ').toLowerCase();
    return haystack.includes(mapSearchNorm);
  });

  /* ===== فلترة الفعاليات بالبحث ===== */
  const filteredEvents = events.filter(ev => {
    const okTitle = !searchTitle || ev.title.includes(searchTitle.trim());
    const okDate  = !searchDate  || ev.rawDate === searchDate;
    const okTime  = !searchTime  || ev.time === searchTime;
    return okTitle && okDate && okTime;
  });

  /* تقسيم الفعاليات حسب الحالة (يعتمد على nowTick للتحديث التلقائي) */
  const eventsWithStatus = filteredEvents.map(ev => ({ ...ev, _status: getEventStatus(ev, nowTick) }));
  /* المتاحة = القادمة + المباشرة (المباشرة أولاً) */
  const availableEvents = eventsWithStatus
    .filter(ev => ev._status === 'upcoming' || ev._status === 'live')
    .sort((a, b) => {
      if (a._status === 'live' && b._status !== 'live') return -1;
      if (b._status === 'live' && a._status !== 'live') return 1;
      const sa = getEventStart(a)?.getTime() || 0;
      const sb = getEventStart(b)?.getTime() || 0;
      return sa - sb;
    });
  /* السابقة (الأحدث أولاً) */
  const pastEvents = eventsWithStatus
    .filter(ev => ev._status === 'past')
    .sort((a, b) => (getEventStart(b)?.getTime() || 0) - (getEventStart(a)?.getTime() || 0));

  /* حد عرض الفعاليات السابقة بالصفحة الرئيسية — الباقي يُشاف بصفحة "عرض الكل" منفصلة */
  /* حد عرض الزبائن (حقيقيين ومسجلين محلياً) بالجدول — الباقي بصفحة "عرض الكل" */
  const PEOPLE_PREVIEW_LIMIT = 20;

  const getFilteredCustomers = () => {
    const norm = customerSearch.trim().toLowerCase();
    return users.filter(u => u.role === 'customer').filter(u => {
      if (!norm) return true;
      const haystack = [u.name, u.email, u.phone].filter(Boolean).join(' ').toLowerCase();
      return haystack.includes(norm);
    });
  };

  const getFilteredLocalCustomers = () => {
    const norm = localCustomerSearch.trim().toLowerCase();
    return localCustomers.filter(c => {
      if (!norm) return true;
      const haystack = [c.name, c.phone, c.registeredBy].filter(Boolean).join(' ').toLowerCase();
      return haystack.includes(norm);
    });
  };

  const PAST_EVENTS_PREVIEW_LIMIT = 20;
  const pastEventsPreview = pastEvents.slice(0, PAST_EVENTS_PREVIEW_LIMIT);
  const shownEventsLimited = eventsTab === 'available' ? availableEvents : pastEventsPreview;

  /* عرض كرت فعالية واحد (يُستخدم بالصفحة الرئيسية وبصفحة "كل الفعاليات السابقة") */
  const renderEventCard = (ev) => {
    const isLive = ev._status === 'live';
    const isPast = ev._status === 'past';
    const openEvent = () => {
      if (isPast && currentUser?.role !== 'admin') { showToast('انتهت هذه الفعالية — لا يمكن الدخول إليها'); return; }
      setSelectedEvent(ev); setCurrentView('map'); setActiveFloor(1); setSelected([]); setMapSearch('');
    };
    return (
      <div
        key={ev.id}
        className={`event-card${isLive ? ' live' : ''}${isPast ? ' past' : ''}`}
        onClick={openEvent}
      >
        {isLive && <span className="live-badge"><span className="dot" />{t('مباشر')}</span>}
        {isPast && <span className="past-badge">{t('منتهية')}</span>}
        <div className="card-admin-btns">
          {canManage && !isPast && <button className="edit-btn-icon" onClick={e => openEditEvent(ev, e)}>⚙️</button>}
          {currentUser?.role === 'admin' && <button className="del-btn-icon" onClick={e => handleDeleteEvent(ev, e)}>🗑️</button>}
        </div>
        <div className="event-card-title">{ev.title}</div>
        <div className="event-card-time">📅 {fmtEventWhen(ev)}</div>
      </div>
    );
  };

  /* ===== إحصائيات المدير ===== */
  const totalCustomers = users.filter(u => u.role === 'customer').length;
  const totalStaff     = users.filter(u => u.role === 'staff').length;
  const totalRevenue   = events.reduce((a, ev) => a + ev.seats.filter(s => s.status === 'booked').reduce((s2, s) => s2 + s.price, 0), 0);

  const bookingCustomerIds = new Set(events.flatMap(ev => ev.seats.filter(s => s.status === 'booked' && s.bookedBy?.id).map(s => s.bookedBy.id)));
  const activeBookers = [...bookingCustomerIds].filter(id => users.find(u => u.id === id && u.role === 'customer')).length;

  const eventStats = events.map(ev => {
    const total = ev.seats.length;
    const booked = ev.seats.filter(s => s.status === 'booked').length;
    const empty = ev.seats.filter(s => s.status === 'available').length;
    const occ = total ? Math.round((booked / total) * 100) : 0;
    const byType = (t) => ev.seats.filter(s => s.type === t && s.status === 'booked').reduce((a, s) => a + s.price, 0);
    return {
      id: ev.id, title: ev.title, total, booked, empty, occ,
      _status: getEventStatus(ev, nowTick),
      revChair: byType('chair'), revSession: byType('session'), revVip: byType('vip'),
      emptyChair: ev.seats.filter(s => s.type === 'chair' && s.status === 'available').length,
      emptySession: ev.seats.filter(s => s.type === 'session' && s.status === 'available').length,
      emptyVip: ev.seats.filter(s => s.type === 'vip' && s.status === 'available').length
    };
  });

  const revenueOnDate = !revenueDate ? null :
    events.filter(ev => ev.rawDate === revenueDate)
      .reduce((a, ev) => a + ev.seats.filter(s => s.status === 'booked').reduce((s2, s) => s2 + s.price, 0), 0);
  const todayStr = new Date().toISOString().slice(0, 10);
  const revenueToday = events.filter(ev => ev.rawDate === todayStr)
    .reduce((a, ev) => a + ev.seats.filter(s => s.status === 'booked').reduce((s2, s) => s2 + s.price, 0), 0);

  const toggleStat = (k) => setOpenStat(prev => prev === k ? null : k);

  return (
    <div>
      {/* ===== TopBar ===== */}
      <div className="topbar">
        <div className="brand" onClick={() => setCurrentView('home')}>
          <img className="logo-img" src={logo} alt={t("قَدُوع كِيف")} />
          <div>
            <h1 style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
              {t('قَدُوع كِيف')}
              <span style={{
                fontSize: '9px', fontWeight: 800, letterSpacing: '0.5px',
                color: '#fff', background: 'var(--blue, #3b82f6)',
                padding: '1px 6px', borderRadius: '6px', lineHeight: 1.6,
                verticalAlign: 'middle', transform: 'translateY(-1px)'
              }}>Beta</span>
              <span style={{
                fontSize: '8px', fontWeight: 800, letterSpacing: '0.3px',
                color: 'var(--blue, #3b82f6)', background: 'transparent',
                border: '1px solid var(--blue, #3b82f6)',
                padding: '0px 5px', borderRadius: '6px', lineHeight: 1.6,
                verticalAlign: 'middle', transform: 'translateY(-1px)'
              }}>v0.3</span>
            </h1>
            <span>{t('منظومة إدارة الجلسات')}</span>
          </div>
        </div>
        <div className="topbar-actions">
          <button className="btn-topbar" onClick={toggleLang} title="Language / اللغة">{lang === 'ar' ? 'EN' : 'ع'}</button>
          {currentUser?.role === 'admin' && (
            <button className="btn-topbar" onClick={() => setCurrentView('admin')}>{t('👑 الإدارة')}</button>
          )}
          {currentUser ? (
            <>
              <div className="user-chip" onClick={() => { setProfileUser({ ...currentUser }); setShowProfileModal(true); }}>
                <span>👤</span>{currentUser.name.split(' ')[0]}
              </div>
              <button className="btn-topbar danger" onClick={handleLogout}>{t('خروج')}</button>
            </>
          ) : (
            <button className="btn-topbar" onClick={() => setShowAuthModal(true)}>{t('تسجيل الدخول')}</button>
          )}
        </div>
      </div>

      <div className="wrap">

        {/* ===== Home + Search ===== */}
        {currentView === 'home' && (
          <div>
            <div className="home-hero">
              <div className="hero-icon">☕</div>
              <h2>{t('أهلاً بك في قَدُوع كِيف')}</h2>
              <p>{t('احجز جلستك وعِش تجربة رايقة')}</p>
            </div>

            {canManage && (
              <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <button className="btn btn-go" onClick={() => { setEditingEvent(null); setEventForm({ title: '', date: '', time: '' }); setShowEventModal(true); }}>{t('+ إنشاء موعد جديد')}</button>
              </div>
            )}

            <div className="search-bar">
              <div className="field"><label>{t('🔎 ابحث بالعنوان')}</label><input placeholder={t("اسم الفعالية")} value={searchTitle} onChange={e => setSearchTitle(e.target.value)} /></div>
              <div className="field"><label>{t('📅 التاريخ')}</label><input type="date" value={searchDate} onChange={e => setSearchDate(e.target.value)} /></div>
              <div className="field"><label>{t('⏰ الوقت')}</label><input type="time" value={searchTime} onChange={e => setSearchTime(e.target.value)} /></div>
              <button className="search-clear" onClick={() => { setSearchTitle(''); setSearchDate(''); setSearchTime(''); }}>{t('مسح')}</button>
            </div>

            <div className="events-tabs">
              <button
                className={`events-tab${eventsTab === 'available' ? ' active' : ''}`}
                onClick={() => setEventsTab('available')}
              >
                {t('🏟️ الفعاليات المتاحة')}
                {availableEvents.some(ev => ev._status === 'live') && <span className="live-count">{t('مباشر الآن')}</span>}
              </button>
              <button
                className={`events-tab${eventsTab === 'past' ? ' active' : ''}`}
                onClick={() => setEventsTab('past')}
              >
                {t('🕓 الفعاليات السابقة')}
              </button>
              {currentUser?.role === 'admin' && eventsTab === 'past' && pastEvents.length > 0 && (
                <button className="btn-danger-sm clear-past-btn" onClick={handleClearPastEvents}>
                  {t('🗑️ حذف كل الفعاليات السابقة')}
                </button>
              )}
            </div>

            {shownEventsLimited.length === 0 ? (
              <div className="empty-state">
                <div className="icon">{eventsTab === 'available' ? '🏟️' : '🕓'}</div>
                {events.length === 0
                  ? t('لا توجد فعاليات حالياً')
                  : eventsTab === 'available'
                    ? t('لا توجد فعاليات متاحة أو مباشرة حالياً')
                    : t('لا توجد فعاليات سابقة')}
              </div>
            ) : (
              <div>
                <div className="events-grid">
                  {shownEventsLimited.map(ev => renderEventCard(ev))}
                </div>
                {eventsTab === 'past' && pastEvents.length > PAST_EVENTS_PREVIEW_LIMIT && (
                  <div style={{ textAlign: 'center', marginTop: '18px' }}>
                    <button className="btn-sm" onClick={() => { setPastEventsFullPage(1); setCurrentView('pastEventsFull'); }}>
                      {t('عرض الكل')} ({pastEvents.length})
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* ===== كل الفعاليات السابقة (صفحة منفصلة) ===== */}
        {currentView === 'pastEventsFull' && (() => {
          const totalPages = Math.max(1, Math.ceil(pastEvents.length / PAST_EVENTS_PREVIEW_LIMIT));
          const page = Math.min(pastEventsFullPage, totalPages);
          const pageItems = pastEvents.slice((page - 1) * PAST_EVENTS_PREVIEW_LIMIT, page * PAST_EVENTS_PREVIEW_LIMIT);
          return (
            <div>
              <div className="bookings-head" style={{ marginBottom: '18px', flexWrap: 'wrap' }}>
                <h3 style={{ margin: 0 }}>{t('كل الفعاليات السابقة')} ({pastEvents.length})</h3>
                <div className="bookings-head-actions">
                  <button className="btn-sm" onClick={() => { setCurrentView('home'); setEventsTab('past'); }}>{t('◂ رجوع')}</button>
                </div>
              </div>
              {pageItems.length === 0
                ? <p style={{ color: 'var(--txt-mut)', textAlign: 'center', padding: '20px 0', fontWeight: 600 }}>{t('لا توجد فعاليات سابقة.')}</p>
                : <div className="events-grid">{pageItems.map(ev => renderEventCard(ev))}</div>}
              {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '14px', margin: '22px 0' }}>
                  <button className="btn-sm" disabled={page <= 1} onClick={() => setPastEventsFullPage(p => Math.max(1, p - 1))}>{t('السابق')}</button>
                  <span style={{ fontWeight: 800 }}>{page} / {totalPages}</span>
                  <button className="btn-sm" disabled={page >= totalPages} onClick={() => setPastEventsFullPage(p => Math.min(totalPages, p + 1))}>{t('التالي')}</button>
                </div>
              )}
            </div>
          );
        })()}

        {/* ===== Map ===== */}
        {/* ===== كل الزبائن الحقيقيين (صفحة منفصلة) ===== */}
        {currentView === 'customersFull' && currentUser?.role === 'admin' && (() => {
          const customersList = getFilteredCustomers();
          const totalPages = Math.max(1, Math.ceil(customersList.length / PEOPLE_PREVIEW_LIMIT));
          const page = Math.min(customersFullPage, totalPages);
          const pageItems = customersList.slice((page - 1) * PEOPLE_PREVIEW_LIMIT, page * PEOPLE_PREVIEW_LIMIT);
          return (
            <div>
              <div className="bookings-head" style={{ marginBottom: '18px', flexWrap: 'wrap' }}>
                <h3 style={{ margin: 0 }}>{t('كل الزبائن')} ({customersList.length})</h3>
                <div className="bookings-head-actions">
                  <button className="btn-sm" onClick={() => { setCurrentView('admin'); setAdminTab('customers'); }}>{t('◂ رجوع')}</button>
                </div>
              </div>
              <div className="table-scroll">
                <table>
                  <thead><tr><th>{t('الاسم الثلاثي')}</th><th>{t('البريد الإلكتروني')}</th><th>{t('الجوال')}</th><th>{t('إجراءات')}</th></tr></thead>
                  <tbody>
                    {pageItems.map(u => (
                      <tr key={u.id}>
                        <td>{u.name}</td>
                        <td dir="ltr">{u.email}</td>
                        <td dir="ltr">{u.phone}</td>
                        <td>
                          <span className="act view" onClick={() => { setProfileUser({ ...u }); setShowProfileModal(true); }}>{t('عرض الملف')}</span>
                          <span className="act view" onClick={() => openAdminEditUser(u)}>{t('تعديل')}</span>
                          <span className="act view" onClick={() => openResetModal(u)}>{t('كلمة المرور')}</span>
                          <span className="act" onClick={() => handleDeleteUser(u.id)}>{t('حذف')}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '14px', margin: '22px 0' }}>
                  <button className="btn-sm" disabled={page <= 1} onClick={() => setCustomersFullPage(p => Math.max(1, p - 1))}>{t('السابق')}</button>
                  <span style={{ fontWeight: 800 }}>{page} / {totalPages}</span>
                  <button className="btn-sm" disabled={page >= totalPages} onClick={() => setCustomersFullPage(p => Math.min(totalPages, p + 1))}>{t('التالي')}</button>
                </div>
              )}
            </div>
          );
        })()}

        {/* ===== كل الزبائن المسجلين محلياً (صفحة منفصلة) ===== */}
        {currentView === 'localCustomersFull' && currentUser?.role === 'admin' && (() => {
          const localList = getFilteredLocalCustomers();
          const totalPages = Math.max(1, Math.ceil(localList.length / PEOPLE_PREVIEW_LIMIT));
          const page = Math.min(localCustomersFullPage, totalPages);
          const pageItems = localList.slice((page - 1) * PEOPLE_PREVIEW_LIMIT, page * PEOPLE_PREVIEW_LIMIT);
          return (
            <div>
              <div className="bookings-head" style={{ marginBottom: '18px', flexWrap: 'wrap' }}>
                <h3 style={{ margin: 0 }}>{t('كل الزبائن المسجلين محلياً')} ({localList.length})</h3>
                <div className="bookings-head-actions">
                  <button className="btn-sm" onClick={() => { setCurrentView('admin'); setAdminTab('localCustomers'); }}>{t('◂ رجوع')}</button>
                </div>
              </div>
              <div className="table-scroll">
                <table>
                  <thead><tr><th>{t('الاسم')}</th><th>{t('الجوال')}</th><th>{t('سجّله')}</th><th>{t('تاريخ التسجيل')}</th><th>{t('إجراءات')}</th></tr></thead>
                  <tbody>
                    {pageItems.map(c => (
                      <tr key={c.id}>
                        <td>{c.name}</td>
                        <td dir="ltr">{c.phone || '—'}</td>
                        <td>{c.registeredBy || '—'}</td>
                        <td>{fmtDateTime(c.registeredAt)}</td>
                        <td>
                          <span className="act view" onClick={() => openEditLocalCustomer(c)}>{t('تعديل')}</span>
                          <span className="act" onClick={() => handleDeleteLocalCustomer(c)}>{t('حذف')}</span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '14px', margin: '22px 0' }}>
                  <button className="btn-sm" disabled={page <= 1} onClick={() => setLocalCustomersFullPage(p => Math.max(1, p - 1))}>{t('السابق')}</button>
                  <span style={{ fontWeight: 800 }}>{page} / {totalPages}</span>
                  <button className="btn-sm" disabled={page >= totalPages} onClick={() => setLocalCustomersFullPage(p => Math.min(totalPages, p + 1))}>{t('التالي')}</button>
                </div>
              )}
            </div>
          );
        })()}

        {currentView === 'map' && selectedEvent && (
          <div>
            <div className="eventhead">
              <button className="map-back" onClick={() => { setCurrentView('home'); setSelected([]); }}>{t('← رجوع')}</button>
              {getEventStatus(selectedEvent, nowTick) === 'live'
                ? <span className="live-badge inline"><span className="dot" />{t('مباشر الآن')}</span>
                : <span className="welcome-tag">{t('🎉 استمتع بأجواء لا تُنسى')}</span>}
              <h2>{selectedEvent.title}</h2>
              <p className="when">📅 {fmtEventWhen(selectedEvent)}</p>
              {currentUser?.role === 'admin' && selectedEvent.createdBy && (
                <p className="creator-tag">{t('🛠️ أُنشئت بواسطة')} <b>{selectedEvent.createdBy}</b> · {fmtDateTime(selectedEvent.createdAt)}</p>
              )}
            </div>

            {viewingPast && (
              <div className="past-viewbanner">
                {t('🔒 فعالية سابقة — للاطّلاع فقط. لا يمكن التعديل، عدا تصحيح الوقت والتاريخ لإعادة تفعيلها.')}
                {currentUser?.role === 'admin' && (
                  <button className="btn-sm" onClick={() => openEditEvent(selectedEvent, { stopPropagation: () => {} })}>{t('🕐 تعديل الوقت والتاريخ')}</button>
                )}
              </div>
            )}

            {canManage && (
              <div className="map-toolbar">
                <div className="map-toolbar-label">🛠️ {t('أدوات الإدارة')}</div>
                <div className="map-toolbar-actions">
                  {canEditSeats && (
                    <button className="tbtn primary" onClick={() => setShowAddSeatModal(true)}>
                      <span className="ti">➕</span>{t('إضافة مقعد')}
                    </button>
                  )}
                  <button className="tbtn" onClick={printEventInvoices}>
                    <span className="ti">🖨️</span>{t('طباعة الفواتير')}
                  </button>
                  {canEditSeats && currentUser?.role === 'admin' && (
                    <button className="tbtn danger" onClick={() => handleDeleteEvent(selectedEvent)}>
                      <span className="ti">🗑️</span>{t('إلغاء الفعالية')}
                    </button>
                  )}
                </div>
              </div>
            )}

            <div className="floortabs">
              <div className={`floortab${activeFloor === 1 ? ' active' : ''}`} onClick={() => setActiveFloor(1)}>{t('الدور الأول')}<small>{t('كراسي + جلسات')}</small></div>
              <div className={`floortab${activeFloor === 2 ? ' active' : ''}`} onClick={() => setActiveFloor(2)}>{t('الدور الثاني')}<small>{t('غرف VIP + جلسات')}</small></div>
            </div>

            {activeFloor === 1
              ? <div className="smoke-note no">{t('🚭 ممنوع التدخين في الدور الأول')}</div>
              : <div className="smoke-note yes">{t('🚬 مسموح التدخين في الدور الثاني')}</div>}

            <div className="legend">
              <span><i className="lg-av" />{t('متاح')}</span>
              <span><i className="lg-sel" />{t('اخترته')}</span>
              <span><i className="lg-pn" />{t('قيد الدفع')}</span>
              <span><i className="lg-bk" />{t('محجوز')}</span>
              <span><i className="lg-vp" />{t('VIP فاخر')}</span>
            </div>

            <div className="arena">
              {activeFloor === 1 && (
                <div className="floor1-wrap">
                  <div>
                    <div className="zone-title-row">
                      <div className="zone-title">{t('الكراسي')}</div>
                      {canEditSeats && <button className="zbtn" onClick={() => openBulkEdit('chair', 1, t('الكراسي'))}>{t('⚙️ تعديل جماعي')}</button>}
                    </div>
                    <div className="chairs-row">
                      <div className="chairs">
                        <div className="chair-grid">{getChairs().map(s => renderSeat(s))}</div>
                      </div>
                      <div className="screen-bar">{t('📺 شاشة الكراسي')}</div>
                    </div>
                  </div>
                  <div className="sessions-block">
                    <div className="zone-title-row">
                      <div className="zone-title">{t('الجلسات الأرضية')}</div>
                      {canEditSeats && <button className="zbtn" onClick={() => openBulkEdit('session', 1, t('الجلسات الأرضية'))}>{t('⚙️ تعديل جماعي')}</button>}
                    </div>
                    <div className="sess-grid">{getF1Sessions().map(s => renderSeat(s))}</div>
                  </div>
                </div>
              )}

              {activeFloor === 2 && (
                <div>
                  <div className="zone-title-row" style={{ marginBottom: '10px' }}>
                    <div className="floor2-title" style={{ marginBottom: 0 }}>{t('👑 الدور الثاني · غرف VIP والجلسات')}</div>
                    {canEditSeats && (
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button className="zbtn" onClick={() => openBulkEdit('vip', 2, t('غرف VIP'))}>{t('⚙️ تعديل VIP')}</button>
                        <button className="zbtn" onClick={() => openBulkEdit('session', 2, t('جلسات الدور الثاني'))}>{t('⚙️ تعديل الجلسات')}</button>
                      </div>
                    )}
                  </div>
                  <div className="vip-grid">{getVIP().map(s => renderSeat(s))}</div>
                  <div className="upper-grid">
                    {getF2Sessions().map(s => renderSeat(s))}
                    <div className="stairs-cell"><div className="ico">🪜</div>{t('الدرج')}</div>
                  </div>
                </div>
              )}
            </div>

            {(currentUser?.role === 'staff' || currentUser?.role === 'admin') && (
              <div className="panel" style={{ marginTop: '24px' }}>
                <div className="panel-head"><h3>{t('🗺️ خريطة الحجوزات الحية')}</h3></div>
                <div className="stats" style={{ padding: '16px 20px', marginBottom: 0, borderBottom: '1px solid var(--line)', gridTemplateColumns: currentUser?.role === 'admin' ? 'repeat(4,1fr)' : 'repeat(3,1fr)' }}>
                  <div className="stat green"><div className="label">{t('متاح')}</div><div className="num">{availableCount}</div></div>
                  <div className="stat coral"><div className="label">{t('حجز ملغي')}</div><div className="num">{cancelledCount}</div></div>
                  <div className="stat"><div className="label">{t('محجوز')}</div><div className="num">{bookedCount}</div></div>
                  {currentUser?.role === 'admin' && <div className="stat gold"><div className="label">{t('الإيراد المؤكد')}</div><div className="num">{revenue}<small> <RiyalIcon /></small></div></div>}
                </div>
                <div className="search-bar" style={{ margin: '16px 20px' }}>
                  <div className="field" style={{ flex: 1 }}>
                    <label>{t('🔎 ابحث برقم الجلسة، النوع، الاسم، أو الجوال')}</label>
                    <input value={mapSearch} onChange={e => setMapSearch(e.target.value)} placeholder={t('مثال: جلسة 3، كرسي، عبدالله، 05...')} />
                  </div>
                  {mapSearch && <button className="search-clear" onClick={() => setMapSearch('')}>{t('مسح')}</button>}
                </div>
                <div className="table-scroll">
                  <table>
                    <thead><tr><th>{t('المقعد')}</th><th>{t('النوع')}</th><th>{t('الزبون')}</th><th>{t('الجوال')}</th><th>{t('الحالة')}</th><th>{t('الوقت')}</th><th>{t('التاريخ')}</th><th>{t('حجزه')}</th>{canEditSeats && <th>{t('إجراء')}</th>}</tr></thead>
                    <tbody>
                      {filteredBookingRows.length === 0 && (
                        <tr><td colSpan={canEditSeats ? 9 : 8} style={{ textAlign: 'center', color: 'var(--txt-mut)', fontWeight: 600, padding: '16px 0' }}>{t('لا نتائج مطابقة.')}</td></tr>
                      )}
                      {filteredBookingRows.map(s => {
                        const tagCls = s.status === 'booked' ? 't-bk' : 't-pn';
                        const tagLbl = s.status === 'booked' ? t('محجوز') : t('قيد الدفع');
                        return (
                          <tr key={s.id}>
                            <td><b>{seatLabel(s.name)}</b></td>
                            <td>{s.type === 'chair' ? t('كرسي') : s.type === 'vip' ? t('غرفة VIP') : t('جلسة')}</td>
                            <td>{displayName(s.bookedBy?.name) || '—'}</td>
                            <td dir="ltr">{s.bookedBy?.phone || '—'}</td>
                            <td><span className={`tag ${tagCls}`}>{tagLbl}</span></td>
                            <td>{fmtTime(s.bookedBy?.bookedAt)}</td>
                            <td>{fmtDate(s.bookedBy?.bookedAt)}</td>
                            <td>{s.bookedBy?.internalBookedBy ? <b>{s.bookedBy.internalBookedBy}</b> : <span style={{ color: 'var(--txt-mut)' }}>{t('الزبون نفسه')}</span>}</td>
                            {canEditSeats && (
                              <td>{s.status === 'booked' && (
                                <div style={{ display: 'inline-flex', gap: '6px', flexWrap: 'nowrap' }}>
                                  <button className="btn-danger-sm" onClick={() => printSeatInvoice(s)}>{t('🖨️ طباعة الفاتورة')}</button>
                                  <button className="btn-danger-sm" onClick={async () => {
                                    if (!window.confirm(t('إعادة فتح المقعد؟'))) return;
                                    try {
                                      const res = await reopenSeatApi(selectedEvent.id, s.id);
                                      replaceEventInState(res.data);
                                      showToast('✅ تم إعادة فتح المقعد');
                                    } catch (err) {
                                      showToast(err.response?.data || t('تعذّر إعادة فتح المقعد'));
                                    }
                                  }}>{t('✕ إعادة فتح')}</button>
                                </div>
                              )}</td>
                            )}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                {currentUser?.role === 'staff' && <p className="staffnote">{t('🔒 الموظف يشوف بيانات الزبون ويقدر يعيد فتح المقاعد')}</p>}
              </div>
            )}

            {(currentUser?.role === 'staff' || currentUser?.role === 'admin') && selectedEvent.cancelledLog?.length > 0 && (
              <div className="panel" style={{ marginTop: '20px' }}>
                <div className="panel-head"><h3>{t('🗑️ سجل الحجوزات الملغاة')}</h3></div>
                <div className="table-scroll">
                  <table>
                    <thead><tr><th>{t('المقعد')}</th><th>{t('النوع')}</th><th>{t('الزبون')}</th><th>{t('الجوال')}</th><th>{t('الوقت')}</th><th>{t('التاريخ')}</th>{currentUser?.role === 'admin' && <th>{t('أُعيد الفتح بواسطة')}</th>}</tr></thead>
                    <tbody>
                      {selectedEvent.cancelledLog.slice().reverse().map(r => (
                        <tr key={r.id}>
                          <td><b>{r.seatName}</b></td>
                          <td>{r.type === 'chair' ? t('كرسي') : r.type === 'vip' ? t('غرفة VIP') : t('جلسة')}</td>
                          <td>{r.customerName}</td>
                          <td dir="ltr">{r.customerPhone}</td>
                          <td>{fmtTime(r.bookedAt)}</td>
                          <td>{fmtDate(r.bookedAt)}</td>
                          {currentUser?.role === 'admin' && <td>{r.canceledBy}</td>}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <p className="staffnote">{t('📌 وقت وتاريخ الحجز الأصلي قبل الإلغاء · مرتّبة من الأحدث للأقدم')}</p>
              </div>
            )}
          </div>
        )}

        {/* ===== Admin Dashboard ===== */}
        {currentView === 'admin' && currentUser?.role === 'admin' && (
          <div>
            <div className="dash-title">{t('👑 لوحة الإدارة')}</div>

            <div className="stats">
              <div className={`stat green${openStat === 'customers' ? ' active' : ''}`} onClick={() => toggleStat('customers')}>
                <div className="label">{t('إجمالي الزبائن')}</div><div className="num">{totalCustomers}</div><div className="tap-hint">{t('اضغط للتفاصيل ↓')}</div>
              </div>
              <div className="stat amber" onClick={() => toggleStat(null)}>
                <div className="label">{t('الموظفين')}</div><div className="num">{totalStaff}</div>
              </div>
              <div className={`stat${openStat === 'events' ? ' active' : ''}`} onClick={() => toggleStat('events')}>
                <div className="label">{t('إجمالي الفعاليات')}</div><div className="num">{events.length}</div><div className="tap-hint">{t('اضغط للتفاصيل ↓')}</div>
              </div>
              <div className={`stat gold${openStat === 'revenue' ? ' active' : ''}`} onClick={() => toggleStat('revenue')}>
                <div className="label">{t('الإيرادات الكلية')}</div><div className="num">{totalRevenue}<small> <RiyalIcon /></small></div><div className="tap-hint">{t('اضغط للتفاصيل ↓')}</div>
              </div>
              <div className={`stat${openStat === 'deleted' ? ' active' : ''}`} onClick={() => toggleStat('deleted')}>
                <div className="label">{t('فعاليات ملغية')}</div><div className="num">{deletedEvents.length}</div><div className="tap-hint">{t('اضغط للسجل ↓')}</div>
              </div>
            </div>

            {openStat === 'customers' && (
              <div className="detail-panel">
                <h4>{t('👥 تفاصيل الزبائن')}</h4>
                <div className="mini-stats">
                  <div className="mini-stat g"><div className="l">{t('زبائن لديهم حجز نشط')}</div><div className="v">{activeBookers}</div></div>
                  <div className="mini-stat y"><div className="l">{t('إجمالي الزبائن المسجلين')}</div><div className="v">{totalCustomers}</div></div>
                  <div className="mini-stat o"><div className="l">{t('زبائن بدون حجز')}</div><div className="v">{totalCustomers - activeBookers}</div></div>
                </div>
              </div>
            )}

            {openStat === 'events' && (
              <div className="detail-panel">
                <h4>{t('🏟️ تفاصيل الفعاليات')}</h4>
                {eventStats.length === 0 ? <p style={{ color: 'var(--txt-mut)', fontWeight: 600 }}>{t('لا توجد فعاليات.')}</p> : (
                  <>
                    <div className="detail-subhead active"><span className="dot-live" />{t('الفعاليات القادمة والمباشرة')}</div>
                    {eventStats.filter(es => es._status !== 'past').length === 0
                      ? <p className="detail-empty">{t('لا توجد فعاليات قادمة أو مباشرة حالياً.')}</p>
                      : eventStats.filter(es => es._status !== 'past').map(es => {
                        const fullEvent = events.find(e => e.id === es.id);
                        return (
                          <div key={es.id} className={`event-stat-row${es._status === 'live' ? ' live' : ''}`}>
                            <div className="top">
                              <h5>{es.title}{es._status === 'live' && <span className="live-badge inline sm"><span className="dot" />{t('مباشر')}</span>}</h5>
                              <span className="occ-badge">{t('نسبة الحجز')} {es.occ}%</span>
                            </div>
                            <p className="creator-tag" style={{ margin: '0 0 6px' }}>📅 {fmtEventWhen(fullEvent)}</p>
                            <p className="creator-tag" style={{ margin: '0 0 10px' }}>{t('🛠️ أُنشئت بواسطة')} <b>{fullEvent?.createdBy || '—'}</b> · {fmtDateTime(fullEvent?.createdAt)}</p>
                            <div className="progress"><div className="fill" style={{ width: `${es.occ}%` }} /></div>
                            <div className="mini-stats">
                              <div className="mini-stat g"><div className="l">{t('محجوز')}</div><div className="v">{es.booked}</div></div>
                              <div className="mini-stat r"><div className="l">{t('فارغ')}</div><div className="v">{es.empty}</div></div>
                              <div className="mini-stat y"><div className="l">{t('إيراد الكراسي')}</div><div className="v">{es.revChair}</div></div>
                              <div className="mini-stat y"><div className="l">{t('إيراد الجلسات')}</div><div className="v">{es.revSession}</div></div>
                              <div className="mini-stat y"><div className="l">{t('إيراد VIP')}</div><div className="v">{es.revVip}</div></div>
                            </div>
                            <p style={{ fontSize: '12px', color: 'var(--txt-mut)', marginTop: '10px', fontWeight: 600 }}>{t('الفارغ:')} {es.emptyChair} {t('كرسي')} · {es.emptySession} {t('جلسة')} · {es.emptyVip} {t('غرفة')}</p>
                          </div>
                        );
                      })}

                    <div className="detail-subhead past"><span className="dot-past" />{t('الفعاليات السابقة')}</div>
                    {eventStats.filter(es => es._status === 'past').length === 0
                      ? <p className="detail-empty">{t('لا توجد فعاليات سابقة.')}</p>
                      : eventStats.filter(es => es._status === 'past').map(es => {
                        const fullEvent = events.find(e => e.id === es.id);
                        return (
                          <div key={es.id} className="event-stat-row past">
                            <div className="top">
                              <h5>{es.title}<span className="past-badge sm">{t('منتهية')}</span></h5>
                              <span className="occ-badge">{t('نسبة الحجز')} {es.occ}%</span>
                            </div>
                            <p className="creator-tag" style={{ margin: '0 0 6px' }}>📅 {fmtEventWhen(fullEvent)}</p>
                            <p className="creator-tag" style={{ margin: '0 0 10px' }}>{t('🛠️ أُنشئت بواسطة')} <b>{fullEvent?.createdBy || '—'}</b> · {fmtDateTime(fullEvent?.createdAt)}</p>
                            <div className="progress"><div className="fill" style={{ width: `${es.occ}%` }} /></div>
                            <div className="mini-stats">
                              <div className="mini-stat g"><div className="l">{t('محجوز')}</div><div className="v">{es.booked}</div></div>
                              <div className="mini-stat r"><div className="l">{t('فارغ')}</div><div className="v">{es.empty}</div></div>
                              <div className="mini-stat y"><div className="l">{t('إيراد الكراسي')}</div><div className="v">{es.revChair}</div></div>
                              <div className="mini-stat y"><div className="l">{t('إيراد الجلسات')}</div><div className="v">{es.revSession}</div></div>
                              <div className="mini-stat y"><div className="l">{t('إيراد VIP')}</div><div className="v">{es.revVip}</div></div>
                            </div>
                            <p style={{ fontSize: '12px', color: 'var(--txt-mut)', marginTop: '10px', fontWeight: 600 }}>{t('الفارغ:')} {es.emptyChair} {t('كرسي')} · {es.emptySession} {t('جلسة')} · {es.emptyVip} {t('غرفة')}</p>
                          </div>
                        );
                      })}
                  </>
                )}
              </div>
            )}

            {openStat === 'revenue' && (
              <div className="detail-panel">
                <h4>{t('💰 تفاصيل الإيرادات')}</h4>
                <div className="mini-stats">
                  <div className="mini-stat g"><div className="l">{t('إيراد اليوم')}</div><div className="v">{revenueToday} <small style={{ fontSize: '13px' }}><RiyalIcon /></small></div></div>
                  <div className="mini-stat y"><div className="l">{t('الإيراد الكلي')}</div><div className="v">{totalRevenue} <small style={{ fontSize: '13px' }}><RiyalIcon /></small></div></div>
                </div>
                <div style={{ marginTop: '18px' }}>
                  <div className="l" style={{ fontSize: '13px', fontWeight: 700, marginBottom: '8px' }}>{t('📅 إيرادات يوم محدد')}</div>
                  <div className="date-revenue-row">
                    <div className="field"><label>{t('اختر التاريخ')}</label><input type="date" value={revenueDate} onChange={e => setRevenueDate(e.target.value)} /></div>
                    {revenueDate && <div className="revenue-result">{revenueOnDate} <RiyalIcon /></div>}
                  </div>
                </div>
              </div>
            )}

            {openStat === 'deleted' && (
              <div className="detail-panel">
                <div className="deleted-head">
                  <h4>{t('🗑️ سجل الفعاليات الملغية')}</h4>
                  {deletedEvents.length > 0 && <button className="btn-danger-sm" onClick={handlePurgeAll}>{t('إفراغ السجل نهائياً')}</button>}
                </div>
                {deletedEvents.length === 0
                  ? <p className="detail-empty">{t('لا توجد فعاليات ملغية.')}</p>
                  : deletedEvents.slice().reverse().map(ev => (
                    <div key={ev.id} className="deleted-row">
                      <div className="deleted-info">
                        <h5>{ev.title}</h5>
                        <p>📅 {fmtEventWhen(ev)}</p>
                        <p className="deleted-meta">{t('أُلغيت بواسطة')} <b>{ev.deletedBy}</b> · {fmtDateTime(ev.deletedAt)}</p>
                      </div>
                      <div className="deleted-actions">
                        <button className="btn-sm" onClick={() => handleRestoreEvent(ev)}>{t('↩️ استرجاع')}</button>
                        <button className="btn-danger-sm" onClick={() => handlePurgeEvent(ev)}>{t('حذف نهائي')}</button>
                      </div>
                    </div>
                  ))}
              </div>
            )}

            <div className="panel">
              <div className="panel-head"><h3>{t('الإدارة التفصيلية')}</h3></div>
              <div className="panel-body">
                <div className="admin-tabs">
                  {[['stats',t('📊 ملخّص')],['staff',t('🧑‍🍳 الموظفين')],['customers',t('👥 الزبائن')],['localCustomers',t('🧾 زبائن مسجلين محلياً')],['pricing',t('💰 إعدادات الفعاليات')],['profile',t('👤 حسابي')]].map(([k, lbl]) => (
                    <button key={k} className={`admin-tab${adminTab === k ? ' active' : ''}`} onClick={() => setAdminTab(k)}>{lbl}</button>
                  ))}
                </div>

                {adminTab === 'stats' && (
                  <div className="mini-stats">
                    <div className="mini-stat g"><div className="l">{t('زبائن لديهم حجز')}</div><div className="v">{activeBookers}</div></div>
                    <div className="mini-stat o"><div className="l">{t('حجوزات ملغاة (كل الفعاليات)')}</div><div className="v">{events.reduce((a, ev) => a + (ev.cancelledLog?.length || 0), 0)}</div></div>
                    <div className="mini-stat y"><div className="l">{t('إيراد اليوم')}</div><div className="v">{revenueToday}</div></div>
                  </div>
                )}

                {adminTab === 'staff' && (
                  <div>
                    <div style={{ marginBottom: '16px' }}>
                      <button className="btn btn-go" style={{ fontSize: '13px', padding: '10px 20px' }} onClick={openStaffModal}>{t('+ إضافة موظف')}</button>
                    </div>
                    <div className="table-scroll">
                      <table>
                        <thead><tr><th>{t('الاسم')}</th><th>{t('البريد الإلكتروني')}</th><th>{t('الجوال')}</th><th>{t('التعديل')}</th><th>{t('إجراء')}</th></tr></thead>
                        <tbody>
                          {users.filter(u => u.role === 'staff').map(u => (
                            <tr key={u.id}>
                              <td>{u.name}</td>
                              <td dir="ltr">{u.email}</td>
                              <td dir="ltr">{u.phone}</td>
                              <td>{u.permissions.canEdit ? '✅' : '❌'}</td>
                              <td>
                                <span className="act view" onClick={() => openAdminEditUser(u)}>{t('تعديل')}</span>
                                <span className="act view" onClick={() => openResetModal(u)}>{t('كلمة المرور')}</span>
                                <button className="btn-danger-sm" onClick={() => handleDeleteUser(u.id)}>{t('حذف')}</button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {adminTab === 'customers' && (() => {
                  const customersList = getFilteredCustomers();
                  const customersPreview = customersList.slice(0, PEOPLE_PREVIEW_LIMIT);
                  return (
                    <div>
                      <div className="search-bar">
                        <div className="field" style={{ flex: 1 }}>
                          <label>{t('🔎 ابحث بالاسم، البريد الإلكتروني، أو الجوال')}</label>
                          <input value={customerSearch} onChange={e => setCustomerSearch(e.target.value)} placeholder={t('اسم الزبون، البريد، أو رقم الجوال')} />
                        </div>
                        {customerSearch && <button className="search-clear" onClick={() => setCustomerSearch('')}>{t('مسح')}</button>}
                      </div>
                      <div className="table-scroll">
                        <table>
                          <thead><tr><th>{t('الاسم الثلاثي')}</th><th>{t('البريد الإلكتروني')}</th><th>{t('الجوال')}</th><th>{t('إجراءات')}</th></tr></thead>
                          <tbody>
                            {customersPreview.length === 0 && (
                              <tr><td colSpan={4} style={{ textAlign: 'center', color: 'var(--txt-mut)', fontWeight: 600, padding: '16px 0' }}>{t('لا نتائج مطابقة.')}</td></tr>
                            )}
                            {customersPreview.map(u => (
                              <tr key={u.id}>
                                <td>{u.name}</td>
                                <td dir="ltr">{u.email}</td>
                                <td dir="ltr">{u.phone}</td>
                                <td>
                                  <span className="act view" onClick={() => { setProfileUser({ ...u }); setShowProfileModal(true); }}>{t('عرض الملف')}</span>
                                  <span className="act view" onClick={() => openAdminEditUser(u)}>{t('تعديل')}</span>
                                  <span className="act view" onClick={() => openResetModal(u)}>{t('كلمة المرور')}</span>
                                  <span className="act" onClick={() => handleDeleteUser(u.id)}>{t('حذف')}</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {customersList.length > PEOPLE_PREVIEW_LIMIT && (
                        <div style={{ textAlign: 'center', marginTop: '14px' }}>
                          <button className="btn-sm" onClick={() => { setCustomersFullPage(1); setCurrentView('customersFull'); }}>
                            {t('عرض الكل')} ({customersList.length})
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {adminTab === 'localCustomers' && (() => {
                  const localList = getFilteredLocalCustomers();
                  const localPreview = localList.slice(0, PEOPLE_PREVIEW_LIMIT);
                  return (
                    <div>
                      <p className="sub" style={{ marginTop: 0 }}>
                        {t('زبائن سجّل بياناتهم موظف أو مدير يدوياً عبر الحجز الداخلي (مو أصحاب حساب فعلي بالموقع).')}
                      </p>
                      <div className="search-bar">
                        <div className="field" style={{ flex: 1 }}>
                          <label>{t('🔎 ابحث بالاسم أو الجوال')}</label>
                          <input value={localCustomerSearch} onChange={e => setLocalCustomerSearch(e.target.value)} placeholder={t('اسم الزبون أو رقم الجوال')} />
                        </div>
                        {localCustomerSearch && <button className="search-clear" onClick={() => setLocalCustomerSearch('')}>{t('مسح')}</button>}
                      </div>
                      <div className="table-scroll">
                        <table>
                          <thead><tr><th>{t('الاسم')}</th><th>{t('الجوال')}</th><th>{t('سجّله')}</th><th>{t('تاريخ التسجيل')}</th><th>{t('إجراءات')}</th></tr></thead>
                          <tbody>
                            {localPreview.length === 0 && (
                              <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--txt-mut)', fontWeight: 600, padding: '16px 0' }}>{t('لا نتائج مطابقة.')}</td></tr>
                            )}
                            {localPreview.map(c => (
                              <tr key={c.id}>
                                <td>{c.name}</td>
                                <td dir="ltr">{c.phone || '—'}</td>
                                <td>{c.registeredBy || '—'}</td>
                                <td>{fmtDateTime(c.registeredAt)}</td>
                                <td>
                                  <span className="act view" onClick={() => openEditLocalCustomer(c)}>{t('تعديل')}</span>
                                  <span className="act" onClick={() => handleDeleteLocalCustomer(c)}>{t('حذف')}</span>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {localList.length > PEOPLE_PREVIEW_LIMIT && (
                        <div style={{ textAlign: 'center', marginTop: '14px' }}>
                          <button className="btn-sm" onClick={() => { setLocalCustomersFullPage(1); setCurrentView('localCustomersFull'); }}>
                            {t('عرض الكل')} ({localList.length})
                          </button>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {adminTab === 'pricing' && (
                  <div style={{ maxWidth: '460px' }}>
                    <p className="sub" style={{ marginTop: 0 }}>
                      {t('الأسعار والأوصاف الافتراضية للمقاعد عند إنشاء أي فعالية جديدة. تُطبّق على الفعاليات الجديدة فقط ولا تغيّر الفعاليات الموجودة.')}
                    </p>
                    <form onSubmit={handleSavePricing}>
                      <div className="field">
                        <label>{t('سعر الكرسي الافتراضي')}</label>
                        <input type="number" min="0" value={pricingForm.chairPrice} onChange={e => setPricingForm(f => ({ ...f, chairPrice: e.target.value }))} required />
                        <div className="hint-mini">{t('الافتراضي الأساسي: 20')} <RiyalIcon /></div>
                      </div>
                      <div className="field">
                        <label>{t('وصف الكرسي الافتراضي')}</label>
                        <input type="text" value={pricingForm.chairInfo} onChange={e => setPricingForm(f => ({ ...f, chairInfo: e.target.value }))} />
                      </div>
                      <div className="field">
                        <label>{t('سعر الجلسة الافتراضي')}</label>
                        <input type="number" min="0" value={pricingForm.sessionPrice} onChange={e => setPricingForm(f => ({ ...f, sessionPrice: e.target.value }))} required />
                        <div className="hint-mini">{t('الافتراضي الأساسي: 70')} <RiyalIcon /></div>
                      </div>
                      <div className="field">
                        <label>{t('وصف الجلسة الافتراضي')}</label>
                        <input type="text" value={pricingForm.sessionInfo} onChange={e => setPricingForm(f => ({ ...f, sessionInfo: e.target.value }))} />
                      </div>
                      <div className="field">
                        <label>{t('سعر الغرفة VIP الافتراضي')}</label>
                        <input type="number" min="0" value={pricingForm.vipPrice} onChange={e => setPricingForm(f => ({ ...f, vipPrice: e.target.value }))} required />
                        <div className="hint-mini">{t('الافتراضي الأساسي: 150')} <RiyalIcon /></div>
                      </div>
                      <div className="field">
                        <label>{t('وصف الغرفة الخاصة (VIP) الافتراضي')}</label>
                        <input type="text" value={pricingForm.vipInfo} onChange={e => setPricingForm(f => ({ ...f, vipInfo: e.target.value }))} />
                      </div>
                      <div className="field" style={{
                        border: '1px dashed var(--line)', borderRadius: '12px', padding: '12px 14px', background: 'var(--bg-3)'
                      }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', margin: 0 }}>
                          <input type="checkbox" checked={!!pricingForm.autoArabicName}
                            onChange={e => setPricingForm(f => ({ ...f, autoArabicName: e.target.checked }))}
                            style={{ width: '18px', height: '18px', cursor: 'pointer' }} />
                          <span>✨ {t('إضافة الترجمة الصوتية للاسم تلقائياً بالحجز الداخلي')}</span>
                        </label>
                        <div className="hint-mini" style={{ marginTop: '6px' }}>
                          {t('لو الموظف كتب اسم الزبون بالإنجليزي فقط، يضيف النظام تلقائياً "- الاسم بالعربي" جنبه، والعكس صحيح لو كتبه بالعربي فقط. تعطيلها يوقف الميزة فوراً حتى بالفعاليات المفتوحة حالياً، ولا يغيّر أي اسم محفوظ سابقاً.')}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '4px' }}>
                        <button type="submit" className="btn btn-go" style={{ fontSize: '14px', padding: '11px 24px' }}>{t('حفظ الأسعار والأوصاف')}</button>
                        <button type="button" className="btn-sm" onClick={handleResetPricing}>{t('↺ إرجاع الافتراضي الأصلي')}</button>
                      </div>
                    </form>
                  </div>
                )}

                {adminTab === 'profile' && (
                  <div style={{ maxWidth: '420px' }}>
                    <form onSubmit={handleUpdateAdminProfile}>
                      <div className="field"><label>{t('الاسم')}</label><input name="adminName" defaultValue={currentUser.name} required /></div>
                      <div className="field"><label>{t('البريد الإلكتروني')}</label><input type="email" name="adminEmail" defaultValue={currentUser.email} required /></div>
                      <div className="field"><label>{t('رقم الجوال')}</label><input name="adminPhone" defaultValue={currentUser.phone} maxLength={10} required /><div className="hint-mini">{t('10 أرقام بالضبط')}</div></div>
                      <div className="field"><label>{t('كلمة مرور جديدة (اختياري)')}</label><input type="password" name="adminPassword" placeholder={t("اتركه فارغاً لعدم التغيير")} /><div className="hint-mini">{t('لو عبّيته: 8 خانات + حرف كبير + رمز')}</div></div>
                      <button type="submit" className="btn btn-go" style={{ fontSize: '14px', padding: '11px 24px' }}>{t('حفظ التعديلات')}</button>
                    </form>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ===== صفحة "عرض الكل" لحجوزات الملف الشخصي (حالية/سابقة/ملغية) ===== */}
        {currentView === 'bookingsFull' && profileUser && (() => {
          const listMap = {
            current: currentBookingsList(),
            past: pastBookingsList(),
            cancelled: cancelledBookings
          };
          const labelMap = {
            current: t('الحجوزات الحالية'),
            past: t('الحجوزات السابقة'),
            cancelled: t('الحجوزات الملغية')
          };
          const list = listMap[bookingsFullCategory] || [];
          const totalPages = Math.max(1, Math.ceil(list.length / BOOKINGS_PAGE_SIZE));
          const page = Math.min(bookingsFullPage, totalPages);
          const pageItems = list.slice((page - 1) * BOOKINGS_PAGE_SIZE, page * BOOKINGS_PAGE_SIZE);
          return (
            <div>
              <div className="bookings-head" style={{ marginBottom: '18px', flexWrap: 'wrap' }}>
                <h3 style={{ margin: 0 }}>{labelMap[bookingsFullCategory]} — {profileUser.name} ({list.length})</h3>
                <div className="bookings-head-actions">
                  <button className="btn-sm" onClick={closeBookingsFullPage}>{t('◂ رجوع للملف الشخصي')}</button>
                </div>
              </div>
              {pageItems.length === 0
                ? <p style={{ color: 'var(--txt-mut)', textAlign: 'center', padding: '20px 0', fontWeight: 600 }}>{t('لا توجد حجوزات.')}</p>
                : pageItems.map(item => bookingsFullCategory === 'cancelled'
                    ? renderCancelledCard(item)
                    : renderBookingCard(item, { showCancel: bookingsFullCategory === 'current' }))}
              {totalPages > 1 && (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '14px', margin: '22px 0' }}>
                  <button className="btn-sm" disabled={page <= 1} onClick={() => setBookingsFullPage(p => Math.max(1, p - 1))}>{t('السابق')}</button>
                  <span style={{ fontWeight: 800 }}>{page} / {totalPages}</span>
                  <button className="btn-sm" disabled={page >= totalPages} onClick={() => setBookingsFullPage(p => Math.min(totalPages, p + 1))}>{t('التالي')}</button>
                </div>
              )}
            </div>
          );
        })()}

      </div>{/* /wrap */}

      {/* ===== Booking Bar ===== */}
      <div className={`bookbar${selected.length > 0 && currentView === 'map' ? ' show' : ''}`}>
        <div className="bookbar-inner">
          <div className="sel-chips">
            {selected.map(s => (
              <span key={s.id} className="chip"><b>{s.name}</b> · {s.price} <RiyalIcon />
                <span className="x" onClick={() => setSelected(prev => prev.filter(x => x.id !== s.id))}>✕</span>
              </span>
            ))}
          </div>
          <div className="bookbar-actions">
            <div className="book-total">{t('الإجمالي:')} <b>{selected.reduce((a, s) => a + s.price, 0)}</b> <RiyalIcon /></div>
            <button className="btn btn-go" onClick={openCheckout}>{t('تأكيد الحجز ←')}</button>
          </div>
          <div className="hint">{t('🪑 الكراسي حتى 4 · 🛋️ الجلسات و VIP حتى 2')}</div>
        </div>
      </div>

      {/* ===== Checkout ===== */}
      {showCheckout && currentUser && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={closeCheckout}>×</button>
            <h3>{t('إتمام الحجز')}</h3>
            <p className="sub">{t('بياناتك مسجّلة في حسابك — لا حاجة لإعادة الكتابة')}</p>
            <div className="prefill-box">
              <div className="label">{t('الحجز باسم')}</div>
              <div className="name">👤 {currentUser.name}</div>
              <div className="phone">📱 {currentUser.phone}</div>
            </div>
            <div className="pay-box">
              <span style={{ fontSize: '20px' }}>💳</span>
              <div><div className="pay-title">{t('الدفع الإلكتروني')}</div><small>{t('سيتم تحويلك لإتمام الدفع بأمان لتأكيد الحجز')}</small></div>
            </div>
            <div className="sum">
              {selected.map(s => <div key={s.id} className="sum-row"><span>{s.name}</span><span>{s.price} <RiyalIcon /></span></div>)}
              <div className="sum-row tot"><span>{t('الإجمالي')}</span><b>{selected.reduce((a, s) => a + s.price, 0)} <RiyalIcon /></b></div>
            </div>
            <div className="cancel-policy">
              ⚠️ <b>{t('سياسة الإلغاء:')}</b> {t('يمكنك إلغاء الحجز واسترداد المبلغ كاملاً قبل موعد الفعالية بـ')} <b>{t('6 ساعات')}</b> {t('على الأقل. بعد ذلك لا يمكن الإلغاء ولا يُسترد المبلغ.')}
            </div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button className="btn btn-muted" style={{ flex: 1 }} onClick={closeCheckout}>{t('رجوع')}</button>
              <button className="btn btn-go" style={{ flex: 2 }} onClick={handleCheckoutConfirm}>{t('الدفع الآن 💳')}</button>
            </div>
          </div>
        </div>
      )}

      {/* ===== Auth ===== */}
      {showAuthModal && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowAuthModal(false)}>×</button>
            <img className="sheet-logo" src={logo} alt={t("قَدُوع كِيف")} />
            <h3 style={{ textAlign: 'center' }}>{t('قَدُوع كِيف')}</h3>
            <p className="sub" style={{ textAlign: 'center' }}>{t('سجّل دخولك أو أنشئ حساباً جديداً')}</p>
            <div className="auth-tabs">
              <div className={`auth-tab${authMode === 'login' ? ' active' : ''}`} onClick={() => { setAuthMode('login'); setAuthCodeSent(false); setAuthCodeValue(''); }}>{t('تسجيل الدخول')}</div>
              <div className={`auth-tab${authMode === 'register' ? ' active' : ''}`} onClick={() => { setAuthMode('register'); setAuthCodeSent(false); setAuthCodeValue(''); }}>{t('حساب جديد')}</div>
            </div>
            <form onSubmit={handleAuthSubmit}>
              {authMode === 'register' && authCodeSent ? (
                <>
                  <p className="sub" style={{ textAlign: 'center' }}>{t('أرسلنا رمز تحقق إلى')} {authEmail}</p>
                  <div className="field"><label>{t('رمز التحقق')}</label><input value={authCodeValue} onChange={e => setAuthCodeValue(e.target.value)} required /></div>
                  <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('تأكيد إنشاء الحساب')}</button>
                  <p style={{ textAlign: 'center', marginTop: '12px' }}>
                    <span style={{ color: 'var(--blue)', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }} onClick={() => { setAuthCodeSent(false); setAuthCodeValue(''); }}>
                      {t('رجوع لتعديل البيانات')}
                    </span>
                  </p>
                </>
              ) : (
                <>
                  {authMode === 'register' && (
                    <>
                      <div className="field"><label>{t('الاسم الثلاثي')}</label><input placeholder={t("عبدالله محمد القحطاني")} value={authName} onChange={e => setAuthName(e.target.value)} required /></div>
                      <div className="field"><label>{t('رقم الجوال')}</label><input type="tel" placeholder="05xxxxxxxx" maxLength={10} value={authPhone} onChange={e => setAuthPhone(e.target.value)} required /><div className="hint-mini">{t('10 أرقام بالضبط')}</div></div>
                    </>
                  )}
                  <div className="field">
                    <label>{t('البريد الإلكتروني')}</label>
                    <input type="email" placeholder="example@mail.com" value={authEmail} onChange={e => setAuthEmail(e.target.value)} required />
                  </div>
                  <div className="field">
                    <label>{t('كلمة المرور')}</label>
                    <input type="password" placeholder="••••••••" value={authPassword} onChange={e => setAuthPassword(e.target.value)} required />
                    {authMode === 'register' && <div className="hint-mini">{t('8 خانات على الأقل + حرف كبير + رمز')}</div>}
                  </div>
                  {authMode === 'login' && (
                    <div style={{ textAlign: 'left', marginBottom: '14px' }}>
                      <span
                        style={{ color: 'var(--blue)', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }}
                        onClick={() => { setShowAuthModal(false); setShowForgotModal(true); }}
                      >
                        {t('نسيت كلمة المرور؟')}
                      </span>
                    </div>
                  )}
                  {authMode === 'register' && (
                    <div className="field" style={{ marginBottom: '12px' }}>
                      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', fontSize: '13px', fontWeight: 600, lineHeight: 1.7 }}>
                        <input type="checkbox" checked={authAgree} onChange={e => setAuthAgree(e.target.checked)} style={{ marginTop: '3px', width: '16px', height: '16px', flexShrink: 0 }} />
                        <span>
                          {t('أقرّ بأنني اطّلعت وأوافق على')}{' '}
                          <span style={{ color: 'var(--blue)', fontWeight: 700, cursor: 'pointer', textDecoration: 'underline' }} onClick={(ev) => { ev.preventDefault(); setShowTermsModal(true); }}>
                            {t('الشروط والأحكام وسياسة الاستخدام')}
                          </span>
                        </span>
                      </label>
                    </div>
                  )}
                  <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{authMode === 'login' ? t('دخول') : t('إرسال رمز التحقق')}</button>
                </>
              )}
            </form>
          </div>
        </div>
      )}

      {/* ===== الشروط والأحكام وسياسة الاستخدام ===== */}
      {showTermsModal && (
        <div className="modal-overlay" style={{ zIndex: 3000 }}>
          <div className="sheet" style={{ maxWidth: '560px', maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}>
            <button className="sheet-close" onClick={() => setShowTermsModal(false)}>×</button>
            <h3 style={{ textAlign: 'center' }}>{t('الشروط والأحكام وسياسة الاستخدام ☕')}</h3>
            <p className="sub" style={{ textAlign: 'center' }}>{t('منصة «قَدُوع كِيف»')}</p>
            <div style={{ overflowY: 'auto', paddingLeft: '4px', paddingRight: '4px', textAlign: 'right', lineHeight: 1.9, fontSize: '13.5px', color: 'var(--text, #333)' }}>
              {TERMS_SECTIONS.map((sec, i) => (
                <div key={i} style={{ marginBottom: '16px' }}>
                  {sec.title && <div style={{ fontWeight: 800, marginBottom: '6px' }}>{t(sec.title)}</div>}
                  {sec.items.map((it, j) => (
                    <p key={j} style={{ margin: '0 0 6px 0' }}>{t(it)}</p>
                  ))}
                </div>
              ))}
            </div>
            <button
              className="btn btn-go"
              style={{ width: '100%', marginTop: '10px', flexShrink: 0 }}
              onClick={() => { setAuthAgree(true); setShowTermsModal(false); }}
            >
              {t('قرأت وأوافق')}
            </button>
          </div>
        </div>
      )}

      {/* ===== Forgot Password (قبل الدخول) — برمز يُرسل للبريد ===== */}
      {showForgotModal && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => { setShowForgotModal(false); setForgotCodeSent(false); setForgotCode(''); }}>×</button>
            <h3>{t('استرجاع كلمة المرور')}</h3>
            {!forgotCodeSent ? (
              <>
                <p className="sub">{t('أدخل بريدك الإلكتروني المسجّل وسنرسل لك رمز تحقق')}</p>
                <form onSubmit={handleForgotSubmit}>
                  <div className="field"><label>{t('البريد الإلكتروني')}</label><input type="email" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} required /></div>
                  <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('إرسال رمز التحقق')}</button>
                </form>
              </>
            ) : (
              <>
                <p className="sub">{t('أرسلنا رمز تحقق إلى')} {forgotEmail}</p>
                <form onSubmit={handleForgotSubmit}>
                  <div className="field"><label>{t('رمز التحقق')}</label><input value={forgotCode} onChange={e => setForgotCode(e.target.value)} required /></div>
                  <div className="field"><label>{t('كلمة المرور الجديدة')}</label><input type="password" value={forgotNewPassword} onChange={e => setForgotNewPassword(e.target.value)} required /><div className="hint-mini">{t('8 خانات على الأقل + حرف كبير + رمز')}</div></div>
                  <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('تعيين كلمة المرور')}</button>
                </form>
              </>
            )}
            <p style={{ textAlign: 'center', marginTop: '14px' }}>
              <span style={{ color: 'var(--blue)', fontWeight: 700, fontSize: '13px', cursor: 'pointer' }} onClick={() => { setShowForgotModal(false); setShowAuthModal(true); setForgotCodeSent(false); setForgotCode(''); }}>
                {t('رجوع لتسجيل الدخول')}
              </span>
            </p>
          </div>
        </div>
      )}

      {/* ===== إعادة تعيين كلمة مرور مستخدم (المدير — بدون رمز) ===== */}
      {showResetModal && resetTargetUser && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowResetModal(false)}>×</button>
            <h3>{t('إعادة تعيين كلمة المرور')}</h3>
            <p className="sub">{resetTargetUser.name} — {resetTargetUser.email}</p>
            <form onSubmit={handleResetPassword}>
              <div className="field"><label>{t('كلمة المرور الجديدة')}</label><input type="password" value={resetNewPassword} onChange={e => setResetNewPassword(e.target.value)} required /><div className="hint-mini">{t('8 خانات على الأقل + حرف كبير + رمز')}</div></div>
              <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('حفظ')}</button>
            </form>
          </div>
        </div>
      )}

      {/* ===== تعديل بيانات مستخدم (المدير — بدون رمز) ===== */}
      {showAdminEditUserModal && editUserTarget && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowAdminEditUserModal(false)}>×</button>
            <h3>{t('تعديل بيانات المستخدم')}</h3>
            <p className="sub">{editUserTarget.role === 'staff' ? t('موظف') : t('زبون')}</p>
            <form onSubmit={handleAdminEditUserSubmit}>
              <div className="field"><label>{t('الاسم')}</label><input value={editUserForm.name} onChange={e => setEditUserForm(f => ({ ...f, name: e.target.value }))} required /></div>
              <div className="field"><label>{t('البريد الإلكتروني')}</label><input type="email" value={editUserForm.email} onChange={e => setEditUserForm(f => ({ ...f, email: e.target.value }))} required /></div>
              <div className="field"><label>{t('رقم الجوال')}</label><input maxLength={10} value={editUserForm.phone} onChange={e => setEditUserForm(f => ({ ...f, phone: e.target.value }))} required /><div className="hint-mini">{t('10 أرقام بالضبط')}</div></div>
              {editUserTarget.role === 'staff' && (
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', cursor: 'pointer', fontWeight: 700, fontSize: '14px' }}>
                  <input type="checkbox" checked={editUserForm.canEdit} onChange={e => setEditUserForm(f => ({ ...f, canEdit: e.target.checked }))} style={{ width: 'auto' }} />
                  {t('صلاحية إنشاء وتعديل المواعيد')}
                </label>
              )}
              <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('حفظ التعديلات')}</button>
            </form>
          </div>
        </div>
      )}

      {/* ===== تعديل بيانات زبون مسجل محلياً ===== */}
      {showEditLocalCustomerModal && editLocalCustomerTarget && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowEditLocalCustomerModal(false)}>×</button>
            <h3>{t('تعديل بيانات زبون مسجل محلياً')}</h3>
            <p className="sub">{t('زبون سجّله موظف أو مدير عبر الحجز الداخلي')}</p>
            <form onSubmit={handleEditLocalCustomerSubmit}>
              <div className="field"><label>{t('الاسم')}</label><input value={editLocalCustomerForm.name} onChange={e => setEditLocalCustomerForm(f => ({ ...f, name: e.target.value }))} required /></div>
              <div className="field"><label>{t('رقم الجوال')}</label><input value={editLocalCustomerForm.phone} onChange={e => setEditLocalCustomerForm(f => ({ ...f, phone: e.target.value }))} /></div>
              <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('حفظ التعديلات')}</button>
            </form>
          </div>
        </div>
      )}

      {/* ===== تغيير البريد الإلكتروني (الزبون — برمز تحقق) ===== */}
      {showChangeEmailModal && (
        <div className="modal-overlay stacked">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowChangeEmailModal(false)}>×</button>
            <h3>{t('تغيير البريد الإلكتروني')}</h3>
            <p className="sub">{t('البريد الحالي:')} {currentUser?.email}</p>
            {!emailCodeSent ? (
              <div>
                <p style={{ fontSize: '13.5px', color: 'var(--txt-mut)', fontWeight: 600, marginBottom: '16px' }}>
                  {t('اضغط الزر لإرسال رمز التحقق إلى بريدك الحالي')}
                </p>
                <button className="btn btn-go" style={{ width: '100%' }} onClick={handleSendEmailCode}>{t('إرسال رمز التحقق')}</button>
              </div>
            ) : (
              <form onSubmit={handleChangeEmailSubmit}>
                <div className="field"><label>{t('البريد الإلكتروني الجديد')}</label><input type="email" value={newEmailValue} onChange={e => setNewEmailValue(e.target.value)} required /></div>
                <div className="field"><label>{t('رمز التحقق')}</label><input value={emailCodeValue} onChange={e => setEmailCodeValue(e.target.value)} required /><div className="hint-mini">{t('تحقق من بريدك الإلكتروني، بما فيه الرسائل المزعجة')}</div></div>
                <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('تأكيد التغيير')}</button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* ===== تغيير كلمة المرور (الزبون — برمز تحقق) ===== */}
      {showChangePasswordModal && (
        <div className="modal-overlay stacked">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowChangePasswordModal(false)}>×</button>
            <h3>{t('تغيير كلمة المرور')}</h3>
            {!pwCodeSent ? (
              <div>
                <p style={{ fontSize: '13.5px', color: 'var(--txt-mut)', fontWeight: 600, marginBottom: '16px' }}>
                  {t('اضغط الزر لإرسال رمز التحقق إلى بريدك الإلكتروني')}
                </p>
                <button className="btn btn-go" style={{ width: '100%' }} onClick={handleSendPwCode}>{t('إرسال رمز التحقق')}</button>
              </div>
            ) : (
              <form onSubmit={handleChangePasswordSubmit}>
                <div className="field"><label>{t('كلمة المرور الجديدة')}</label><input type="password" value={newPasswordValue} onChange={e => setNewPasswordValue(e.target.value)} required /><div className="hint-mini">{t('8 خانات على الأقل + حرف كبير + رمز')}</div></div>
                <div className="field"><label>{t('رمز التحقق')}</label><input value={pwCodeValue} onChange={e => setPwCodeValue(e.target.value)} required /><div className="hint-mini">{t('تحقق من بريدك الإلكتروني، بما فيه الرسائل المزعجة')}</div></div>
                <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('تأكيد التغيير')}</button>
              </form>
            )}
          </div>
        </div>
      )}

      {/* ===== تعديل جماعي للمقاعد ===== */}
      {showBulkEditModal && bulkEditTarget && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowBulkEditModal(false)}>×</button>
            <h3>{t('تعديل جماعي')}</h3>
            <p className="sub">{t('سيُطبّق التعديل على كل مقاعد')} "{bulkEditTarget.label}" {t('دفعة وحدة (الاسم والحالة يبقون كما هم)')}</p>
            <form onSubmit={handleBulkEditSubmit}>
              <div className="field"><label>{t('الوصف')}</label><input value={bulkEditForm.info} onChange={e => setBulkEditForm(f => ({ ...f, info: e.target.value }))} required /></div>
              <div className="field"><label>{t('السعر (ريال)')}</label><input type="number" value={bulkEditForm.price} onChange={e => setBulkEditForm(f => ({ ...f, price: e.target.value }))} required /></div>
              <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('تطبيق على الجميع')}</button>
            </form>
          </div>
        </div>
      )}

      {/* ===== Profile ===== */}
      {showProfileModal && profileUser && (
        <div className="modal-overlay">
          <div className="sheet large">
            <button className="sheet-close" onClick={() => setShowProfileModal(false)}>×</button>
            <h3>{t('الملف الشخصي')}</h3>
            <p className="sub">{profileUser.name}</p>
            {(() => {
              const isStaffProfile = profileUser.role === 'staff';
              const adminEditingStaff = currentUser?.role === 'admin';
              const canEditFields = !isStaffProfile || adminEditingStaff;
              if (!canEditFields) {
                return (
                  <div className="prefill-box">
                    <div className="label">{t('بياناتك (للتعديل راجع المدير)')}</div>
                    <div className="name">👤 {profileUser.name}</div>
                    <div className="phone">📱 {profileUser.phone}</div>
                  </div>
                );
              }
              return (
                <div className="prefill-box" style={{ marginBottom: '20px' }}>
                  <div className="label">{t('بياناتك')}</div>
                  <div className="name">👤 {profileUser.name}</div>
                  <div className="phone">📱 {profileUser.phone} · ✉️ {profileUser.email}</div>
                </div>
              );
            })()}

            {profileUser.role === 'customer' && currentUser?.id === profileUser.id && (
              <div className="security-box">
                <h4 style={{ fontFamily: 'Cairo, sans-serif', fontWeight: 900, fontSize: '15px', marginBottom: '12px' }}>{t('🔐 الأمان')}</h4>
                <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '20px' }}>
                  <button className="btn-sm" onClick={openChangeEmailModal}>{t('تغيير البريد الإلكتروني')}</button>
                  <button className="btn-sm" onClick={openChangePasswordModal}>{t('تغيير كلمة المرور')}</button>
                </div>
              </div>
            )}

            {profileUser.role === 'customer' && (() => {
              const current = currentBookingsList();
              const past = pastBookingsList();
              const sectionArrow = (key) => openBookingSection === key ? '▾' : '◂';
              return (
                <>
                  {/* ===== الحجوزات الحالية ===== */}
                  <div
                    className="bookings-head"
                    style={{ cursor: 'pointer', userSelect: 'none' }}
                    onClick={() => setOpenBookingSection(prev => prev === 'current' ? null : 'current')}
                  >
                    <h3 style={{ margin: 0 }}>{sectionArrow('current')} {t('الحجوزات الحالية')} ({current.length})</h3>
                  </div>
                  {openBookingSection === 'current' && (
                    <>
                      {current.length === 0
                        ? <p style={{ color: 'var(--txt-mut)', textAlign: 'center', padding: '20px 0', fontWeight: 600 }}>{t('لا توجد حجوزات حالية.')}</p>
                        : (
                          <>
                            <div className="bookings-head-actions" style={{ marginBottom: '14px' }}>
                              <button className="btn-sm" onClick={printCurrentInvoices}>{t('🖨️ طباعة الفواتير')}</button>
                              {(currentUser?.role === 'admin' || currentUser?.id === profileUser.id) && (
                                <button className="btn-danger-sm" onClick={cancelAllProfileBookings}>{t('إلغاء الكل')}</button>
                              )}
                            </div>
                            {current.slice(0, BOOKINGS_PREVIEW_LIMIT).map(b => renderBookingCard(b, { showCancel: true }))}
                            {current.length > BOOKINGS_PREVIEW_LIMIT && (
                              <button className="btn-sm" style={{ display: 'block', margin: '0 auto 20px' }} onClick={() => openBookingsFullPage('current')}>
                                {t('عرض الكل')} ({current.length})
                              </button>
                            )}
                          </>
                        )}
                    </>
                  )}

                  {/* ===== الحجوزات السابقة ===== */}
                  <div
                    className="bookings-head"
                    style={{ cursor: 'pointer', userSelect: 'none', marginTop: '18px' }}
                    onClick={() => setOpenBookingSection(prev => prev === 'past' ? null : 'past')}
                  >
                    <h3 style={{ margin: 0 }}>{sectionArrow('past')} {t('الحجوزات السابقة')} ({past.length})</h3>
                  </div>
                  {openBookingSection === 'past' && (
                    <>
                      {past.length === 0
                        ? <p style={{ color: 'var(--txt-mut)', textAlign: 'center', padding: '20px 0', fontWeight: 600 }}>{t('لا توجد حجوزات سابقة.')}</p>
                        : (
                          <>
                            <div className="bookings-head-actions" style={{ marginBottom: '14px' }}>
                              <button className="btn-sm" onClick={printPastInvoices}>{t('🖨️ طباعة الفواتير')}</button>
                            </div>
                            {past.slice(0, BOOKINGS_PREVIEW_LIMIT).map(b => renderBookingCard(b, { showCancel: false }))}
                            {past.length > BOOKINGS_PREVIEW_LIMIT && (
                              <button className="btn-sm" style={{ display: 'block', margin: '0 auto 20px' }} onClick={() => openBookingsFullPage('past')}>
                                {t('عرض الكل')} ({past.length})
                              </button>
                            )}
                          </>
                        )}
                    </>
                  )}

                  {/* ===== الحجوزات الملغية ===== */}
                  <div
                    className="bookings-head"
                    style={{ cursor: 'pointer', userSelect: 'none', marginTop: '18px' }}
                    onClick={() => setOpenBookingSection(prev => prev === 'cancelled' ? null : 'cancelled')}
                  >
                    <h3 style={{ margin: 0 }}>{sectionArrow('cancelled')} {t('الحجوزات الملغية')} ({cancelledBookings.length})</h3>
                  </div>
                  {openBookingSection === 'cancelled' && (
                    <>
                      {cancelledBookings.length === 0
                        ? <p style={{ color: 'var(--txt-mut)', textAlign: 'center', padding: '20px 0', fontWeight: 600 }}>{t('لا توجد حجوزات ملغية.')}</p>
                        : (
                          <>
                            <div className="bookings-head-actions" style={{ marginBottom: '14px' }}>
                              <button className="btn-sm" onClick={printCancelledInvoices}>{t('🖨️ طباعة الفواتير')}</button>
                            </div>
                            {cancelledBookings.slice(0, BOOKINGS_PREVIEW_LIMIT).map(c => renderCancelledCard(c))}
                            {cancelledBookings.length > BOOKINGS_PREVIEW_LIMIT && (
                              <button className="btn-sm" style={{ display: 'block', margin: '0 auto 20px' }} onClick={() => openBookingsFullPage('cancelled')}>
                                {t('عرض الكل')} ({cancelledBookings.length})
                              </button>
                            )}
                          </>
                        )}
                    </>
                  )}
                </>
              );
            })()}
          </div>
        </div>
      )}

      {/* ===== Seat Modal (staff/admin) ===== */}
      {showSeatModal && selectedSeat && currentUser && currentUser.role !== 'customer' && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => { setShowSeatModal(false); setIsEditingSeat(false); }}>×</button>
            {!isEditingSeat ? (
              <>
                <h3>{seatLabel(selectedSeat.name)}</h3>
                <p className="sub">{t(selectedSeat.info)}</p>
                {selectedSeat.bookedBy && (
                  <div className="seat-info-who">
                    <div className="siw-head">
                    <div className="siw-name who-name-row">
                        <span className="who-customer-name">👤 {displayName(selectedSeat.bookedBy.name)}</span>
                        {selectedSeat.bookedBy.internalBookedBy && <InternalBadge />}
                      </div>
                      {selectedSeat.bookedBy.phone && selectedSeat.bookedBy.phone !== '-' && (
                        <div className="siw-phone" dir="ltr">📱 {selectedSeat.bookedBy.phone}</div>
                      )}
                    </div>

                    {selectedSeat.bookedBy.note && (
                      <div className="siw-note">📝 {selectedSeat.bookedBy.note}</div>
                    )}

                    {selectedSeat.bookedBy.paymentStatus && (
                      <div className="siw-pay">
                        <div className="siw-pay-grid">
                          <div className="siw-cell"><span>{t('السعر')}</span><b>{selectedSeat.price}</b></div>
                          <div className="siw-cell"><span>{t('المدفوع')}</span><b>{selectedSeat.bookedBy.paidTotal || 0}</b></div>
                          <div className="siw-cell"><span>{t('المتبقي')}</span><b>{selectedSeat.bookedBy.remaining || 0}</b></div>
                        </div>
                        <div className="siw-methods">
                          <span>💵 {t('كاش')}: <b>{selectedSeat.bookedBy.paidCash || 0}</b></span>
                          <span>💳 {t('شبكة')}: <b>{selectedSeat.bookedBy.paidNetwork || 0}</b></span>
                        </div>
                        <div className={`siw-status ${selectedSeat.bookedBy.paymentStatus}`}>
                          {selectedSeat.bookedBy.paymentStatus === 'paid' ? t('تم الدفع')
                            : selectedSeat.bookedBy.paymentStatus === 'partial' ? t('دفع جزئي')
                            : t('لم يتم الدفع')}
                        </div>
                      </div>
                    )}

                    <div className="siw-meta">
                      <div>🕒 {fmtTime(selectedSeat.bookedBy.bookedAt)} · {fmtDate(selectedSeat.bookedBy.bookedAt)}</div>
                      {selectedSeat.bookedBy.internalBookedBy && (
                        <div>🧾 {t('حجز داخلي بواسطة')} {selectedSeat.bookedBy.internalBookedBy}</div>
                      )}
                    </div>
                  </div>
                )}
                {!selectedSeat.bookedBy?.paymentStatus && (
                  <p className="seat-price">{selectedSeat.price} <RiyalIcon /></p>
                )}
                {canEditSeats ? (
                  <div className="seat-actions">
                    {selectedSeat.status === 'booked' && selectedSeat.bookedBy?.internalBookedBy && (
                      <button className="btn-go-sm" onClick={openEditInternalBook}>{t('✏️ تعديل الحجز الداخلي')}</button>
                    )}
                    <button className="btn-sm" onClick={() => { setSeatForm(selectedSeat); setIsEditingSeat(true); }}>{t('⚙️ تعديل المعلومات والسعر')}</button>
                    {selectedSeat.status === 'available' && <button className="btn-go-sm" onClick={openInternalBook}>{t('حجز داخلي (إغلاق المقعد)')}</button>}
                    {selectedSeat.status === 'booked' && <button className="btn-sm" onClick={() => printSeatInvoice(selectedSeat)}>{t('🖨️ طباعة الفاتورة')}</button>}
                    {selectedSeat.status === 'booked' && <button className="btn-danger-sm" onClick={() => handleSeatAction('cancel')}>{t('إعادة فتح المقعد')}</button>}
                    {!selectedSeat.isDefault && <button className="btn-danger-sm" onClick={() => handleSeatAction('delete')}>{t('🗑️ حذف هذا المقعد')}</button>}
                  </div>
                ) : viewingPast && canManage ? (
                  <p className="staffnote" style={{ marginTop: '14px' }}>{t('🔒 فعالية سابقة — عرض فقط، لا يمكن التعديل')}</p>
                ) : null}
              </>
            ) : (
              <form onSubmit={e => { e.preventDefault(); handleSeatAction('save_edit'); }}>
                <h3 style={{ marginBottom: '20px' }}>{t('تعديل المقعد')}</h3>
                <div className="field"><label>{t('الاسم')}</label><input value={seatForm.name} onChange={e => setSeatForm(f => ({ ...f, name: e.target.value }))} required /></div>
                <div className="field"><label>{t('الوصف')}</label><input value={seatForm.info} onChange={e => setSeatForm(f => ({ ...f, info: e.target.value }))} required /></div>
                <div className="field"><label>{t('السعر')}</label><input type="number" value={seatForm.price} onChange={e => setSeatForm(f => ({ ...f, price: e.target.value }))} required /></div>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <button type="button" className="btn btn-muted" style={{ flex: 1 }} onClick={() => setIsEditingSeat(false)}>{t('إلغاء')}</button>
                  <button type="submit" className="btn btn-go" style={{ flex: 2 }}>{t('حفظ التعديلات')}</button>
                </div>
              </form>
            )}
          </div>
        </div>
      )}

      {/* ===== Event Modal ===== */}
      {showEventModal && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowEventModal(false)}>×</button>
            <h3>{editingEvent ? t('تعديل الموعد') : t('إضافة موعد جديد')}</h3>
            <p className="sub">{t('سيتم توليد الخريطة (27 مقعد) تلقائياً عند الحفظ')}</p>
            <form onSubmit={handleSaveEvent}>
              <div className="field"><label>{t('عنوان الفعالية')}</label><input value={eventForm.title} placeholder={t("مثال: الكلاسيكو · الهلال × النصر")} onChange={e => setEventForm(f => ({ ...f, title: e.target.value }))} required /></div>
              <div className="field"><label>{t('التاريخ')}</label><input type="date" value={eventForm.date} onChange={e => setEventForm(f => ({ ...f, date: e.target.value }))} required /></div>
              <div className="field"><label>{t('وقت البداية')}</label><input type="time" value={eventForm.time} onChange={e => setEventForm(f => ({ ...f, time: e.target.value }))} required /></div>
              <div className="field"><label>{t('وقت النهاية (اختياري)')}</label><input type="time" value={eventForm.endTime} onChange={e => setEventForm(f => ({ ...f, endTime: e.target.value }))} /><div className="hint-mini">{t('لو تركته فارغاً تُعتبر الفعالية مباشرة لمدة ساعة. عند وصول وقت النهاية تصبح الفعالية سابقة.')}</div></div>
              <button type="submit" className="btn btn-go" style={{ width: '100%', marginTop: '4px' }}>{t('حفظ')}</button>
            </form>
          </div>
        </div>
      )}

      {/* ===== Add Seat ===== */}
      {showAddSeatModal && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowAddSeatModal(false)}>×</button>
            <h3>{t('إضافة مقعد أو جلسة')}</h3>
            <p className="sub">{t('سيضاف المقعد لخريطة الفعالية الحالية')}</p>
            <form onSubmit={handleAddSeat}>
              <div className="field"><label>{t('النوع')}</label>
                <select value={newSeatForm.type} onChange={e => setNewSeatForm(f => ({ ...f, type: e.target.value }))}>
                  <option value="chair">{t('كرسي')}</option><option value="session">{t('جلسة')}</option><option value="vip">{t('غرفة VIP')}</option>
                </select>
              </div>
              <div className="field"><label>{t('الدور')}</label>
                <select value={newSeatForm.floor} onChange={e => setNewSeatForm(f => ({ ...f, floor: e.target.value }))}>
                  <option value="1">{t('الدور الأول')}</option><option value="2">{t('الدور الثاني')}</option>
                </select>
              </div>
              <div className="field"><label>{t('الاسم')}</label><input placeholder={t("كرسي 15")} value={newSeatForm.name} onChange={e => setNewSeatForm(f => ({ ...f, name: e.target.value }))} required /></div>
              <div className="field"><label>{t('الوصف')}</label><input placeholder={t("مع مشروب...")} value={newSeatForm.info} onChange={e => setNewSeatForm(f => ({ ...f, info: e.target.value }))} required /></div>
              <div className="field"><label>{t('السعر (ريال)')}</label><input type="number" value={newSeatForm.price} onChange={e => setNewSeatForm(f => ({ ...f, price: e.target.value }))} required /></div>
              <button type="submit" className="btn btn-go" style={{ width: '100%', marginTop: '4px' }}>{t('إضافة للمخطط')}</button>
            </form>
          </div>
        </div>
      )}

      {/* ===== Internal Booking Modal (حجز داخلي ببيانات لحظية) ===== */}
      {showInternalBookModal && selectedSeat && (
        <div className="modal-overlay stacked">
          <div className="sheet">
            <button className="sheet-close" onClick={() => { setShowInternalBookModal(false); setIsEditingInternal(false); }}>×</button>
            <h3>{isEditingInternal ? t('تعديل الحجز —') : t('حجز داخلي —')} {seatLabel(selectedSeat.name)}</h3>
            <p className="sub">{isEditingInternal ? t('عدّل بيانات الحجز الداخلي القائم') : t('بيانات لحظية لهذه الفعالية فقط · لا تحتاج تسجيل حساب')}</p>
            <form onSubmit={handleInternalBook}>
              <div className="field"><label>{t('اسم الزبون')} <small style={{ color: 'var(--txt-mut)', fontWeight: 600 }}>{t('(اتركه فاضي = حجز داخلي)')}</small></label><input value={internalBookForm.name} onChange={e => setInternalBookForm(f => ({ ...f, name: e.target.value }))} placeholder={t("اتركه فاضي أو اكتب اسم الزبون")} /></div>

              <div className="field"><label>{t('رقم الجوال')} <small style={{ color: 'var(--txt-mut)', fontWeight: 600 }}>{t('(اتركه فاضي = —)')}</small></label><input dir="ltr" inputMode="numeric" value={internalBookForm.phone} onChange={e => setInternalBookForm(f => ({ ...f, phone: e.target.value.replace(/\D/g, '') }))} placeholder={t("اتركه فاضي أو اكتب الرقم")} /><div className="hint-mini">{t('أرقام فقط · لو تركته فاضي يتحفظ كـ (—)')}</div></div>

              <div className="field"><label>{t('ملاحظة')} <small style={{ color: 'var(--txt-mut)', fontWeight: 600 }}>{t('(اختياري)')}</small></label><textarea rows={2} value={internalBookForm.note} onChange={e => setInternalBookForm(f => ({ ...f, note: e.target.value }))} placeholder={t("مثال: يجلس مع مجموعة جدول 3 · طلب خاص...")} /></div>

              {/* ===== قسم الدفع ===== */}
              {(() => {
                const price = selectedSeat.price || 0;
                const paid = sumByMethod(internalBookForm.payments, 'cash') + sumByMethod(internalBookForm.payments, 'network');
                const remaining = Math.max(0, price - paid);
                const payStatus = paid <= 0 ? t('لم يتم الدفع') : paid >= price ? t('تم الدفع') : t('دفع جزئي');
                const payClass = paid <= 0 ? 'unpaid' : paid >= price ? 'paid' : 'partial';
                return (
                  <div className="ib-pay">
                    <div className="ib-pay-head">
                      <span className="ib-pay-title">💳 {t('الدفع')}</span>
                      <span className="pay-price">{t('سعر الجلسة')} <b>{price}</b> <RiyalIcon /></span>
                    </div>

                    <div className="pay-rows">
                      {internalBookForm.payments.map((p, idx) => (
                        <div className="pay-row" key={idx}>
                          <select value={p.method} onChange={e => updatePaymentRow(idx, { method: e.target.value })}>
                            <option value="cash">{t('كاش')}</option>
                            <option value="network">{t('شبكة')}</option>
                          </select>
                          <input
                            dir="ltr" inputMode="numeric" placeholder={t('المبلغ')}
                            value={p.amount}
                            onChange={e => updatePaymentRow(idx, { amount: e.target.value.replace(/\D/g, '') })}
                          />
                          <button
                            type="button"
                            className="pay-del"
                            onClick={() => removePaymentRow(idx)}
                            disabled={internalBookForm.payments.length <= 1}
                            aria-label={t('حذف الدفعة')}
                          >×</button>
                        </div>
                      ))}
                    </div>

                    <button type="button" className="pay-add" onClick={addPaymentRow}>➕ {t('إضافة دفعة أخرى')}</button>

                    <div className="pay-summary">
                      <div className="pay-sum-item"><span>{t('المدفوع')}</span><b>{paid} <RiyalIcon /></b></div>
                      <div className="pay-sum-item"><span>{t('المتبقي')}</span><b>{remaining} <RiyalIcon /></b></div>
                    </div>
                    <div className={`pay-status-bar ${payClass}`}>{payStatus}</div>
                    <div className="hint-mini">{t('فاضي = ما دفع شي · المبلغ كامل = تم الدفع تلقائياً')}</div>
                  </div>
                );
              })()}

              <button type="submit" className="btn btn-go" style={{ width: '100%', marginTop: '4px' }}>{isEditingInternal ? t('حفظ التعديلات') : t('تأكيد الحجز الداخلي')}</button>
            </form>
          </div>
        </div>
      )}

      {/* ===== Staff Modal ===== */}
      {showStaffModal && (
        <div className="modal-overlay">
          <div className="sheet">
            <button className="sheet-close" onClick={() => setShowStaffModal(false)}>×</button>
            <h3>{t('إضافة موظف جديد')}</h3>
            <p className="sub">{t('سيتمكن الموظف من الدخول بالبريد الإلكتروني')}</p>
            <form onSubmit={handleAddStaff}>
              <div className="field"><label>{t('اسم الموظف')}</label><input placeholder={t("الاسم الكامل")} value={staffForm.name} onChange={e => setStaffForm(f => ({ ...f, name: e.target.value }))} required /></div>
              <div className="field"><label>{t('البريد الإلكتروني')}</label><input type="email" placeholder="staff@qadooa.com" value={staffForm.email} onChange={e => setStaffForm(f => ({ ...f, email: e.target.value }))} required /></div>
              <div className="field"><label>{t('رقم الجوال')}</label><input placeholder="05xxxxxxxx" maxLength={10} value={staffForm.phone} onChange={e => setStaffForm(f => ({ ...f, phone: e.target.value }))} required /><div className="hint-mini">{t('10 أرقام بالضبط')}</div></div>
              <div className="field"><label>{t('كلمة المرور')}</label><input type="password" placeholder="••••••••" value={staffForm.password} onChange={e => setStaffForm(f => ({ ...f, password: e.target.value }))} required /><div className="hint-mini">{t('8 خانات على الأقل + حرف كبير + رمز')}</div></div>
              <label style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', cursor: 'pointer', fontWeight: 700, fontSize: '14px' }}>
                <input type="checkbox" checked={staffForm.canEdit} onChange={e => setStaffForm(f => ({ ...f, canEdit: e.target.checked }))} style={{ width: 'auto' }} />
                {t('صلاحية إنشاء وتعديل المواعيد')}
              </label>
              <button type="submit" className="btn btn-go" style={{ width: '100%' }}>{t('حفظ الموظف')}</button>
            </form>
          </div>
        </div>
      )}

      <div className={`toast${toastOn ? '' : ' hidden'}`}>{toastMsg}</div>
      {/* ===== Footer ===== */}
      <footer style={{
        marginTop: '40px', padding: '18px 16px', borderTop: '1px solid var(--line, #e5e5e5)',
        display: 'flex', flexWrap: 'wrap', gap: '8px 14px', justifyContent: 'center', alignItems: 'center',
        fontSize: '13px', color: 'var(--txt-mut, #888)', textAlign: 'center'
      }}>
        <span>{t('للتواصل والاقتراحات')}: <a href="tel:0502240220" dir="ltr" style={{ color: 'var(--blue)', fontWeight: 700, textDecoration: 'none' }}>0502240220</a></span>
        <span aria-hidden="true">·</span>
        <a href="https://maps.app.goo.gl/mTaJNgrEBUKWwKcA9?g_st=ic" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--blue)', fontWeight: 700, textDecoration: 'none' }}>{t('موقع المكان')}</a>
        <span aria-hidden="true">·</span>
        <span onClick={() => setShowTermsModal(true)} style={{ color: 'var(--blue)', fontWeight: 700, cursor: 'pointer' }}>{t('الشروط والأحكام')}</span>
      </footer>
    </div>
  );
}

export default App;